<template>
  <div class="Lanchpad" :class="{lan_En : lan != 'zh'}" @scroll.passive="handleScroll">
    <div class="content content1">
      <div class="meteor"></div>
      <div class="meteor1"></div>
      <div class="meteor2"></div>
      <div class="bg1"></div>
      <div class="bg2"></div>
      <div class="bg3"></div>
      <div class="bg4"></div>
      <div class="bg5"></div>
      <div class="bg6"></div>
      <div class="bg7"></div>
      <div class="bg8"></div>
      <div class="bg9"></div>
      <div class="bg10"></div>
      <div class="bg11"></div>
      <div class="line_point" v-for="(item, index) in pointList" :class="{active: item.active &&  !item.samll, small: item.samll ? item.active && item.samll :false }" :style="{'top': item.top+'px'}" :key="index"></div>
      <div class="line" ref="lineRef"><img src="../assets/line.svg" alt=""></div>
      <div class="line3"></div>
      <div class="line2"></div>
      <div class="cont cont1">
        <div class="title">
          <p>{{ $t('lanchpad.cont1.title1') }}</p>
          <p>{{ $t('lanchpad.cont1.desc') }}</p>
        </div>
        <div class="desc">{{ $t('lanchpad.cont1.title2') }}</div>
        <div class="btnList">
          <!-- <div class="btn" @click="linkHref('https://www.pinksale.finance/launchpad/0x38300f83021D5461cf2073725aA27aa45a3306ad?chain=ETH')">{{ $t('lanchpad.cont1.btn1') }}</div> -->
          <div class="btn" @click="downLoad('white')">{{ $t('lanchpad.cont1.btn2') }}</div>
          <div class="btn" @click="downLoad('Protocol')">{{ $t('lanchpad.cont1.btn3') }}</div> 
        </div>
        <div class="tips">{{ $t('lanchpad.cont1.desc1') }}</div>
        <div class="gif"><img src="../assets/lanch.gif" alt=""></div>
      </div>
      <div class="cont cont2">
        <div class="videoPaly">
          <video ref="videoRef" src="https://www.deeplink.cloud/vedio.mp4"
            loop="loop" 
            muted="muted" 
            controls="controls"
            controlsList="noplaybackrate, nopip">
          </video>
        </div>
        <div class="imgbg">
          <div class="video1">
            <video src="../assets/lanch_video1.mp4"
              loop="loop" 
              muted="muted" 
              autoplay>
            </video>
          </div>
          <div class="text">Distance:50km</div>
          <div class="video2">
            <video src="../assets/lanch_video2.mp4"
              loop="loop" 
              muted="muted" 
              autoplay>
            </video>
          </div>
          <!-- <div class="text">
            <div class="text1">{{ $t('lanchpad.cont2.desc1') }}</div>
            <div class="text2">{{ $t('lanchpad.cont2.desc1') }} </div>
          </div> -->
        </div>
        <!-- <div class="videoBtn" @click="dialogTableVisible = true">{{ $t('lanchpad.cont2.btn') }}</div> -->
      </div>
      <div class="cont cont3">
        <div class="warp-data" ref="wrapper">
          <div class="data_ul" ref="marquee" @mouseover="mouseover" @mouseout="mouseout">
            <div ref="warp_cont">
              <div class="data_li">
                <div class="left">1ms</div>
                <span>{{ $t('lanchpad.cont3.text1') }}</span>
              </div>
              <div class="data_li">
                <div class="left">8K</div>
                <span>{{ $t('lanchpad.cont3.text2') }}</span>
              </div>
              <div class="data_li">
                <div class="left">244Hz</div>
                <span>{{ $t('lanchpad.cont3.text3') }}</span>
              </div>
              <div class="data_li">
                <div class="left">24H</div>
                <span>{{ $t('lanchpad.cont3.text4') }}</span>
              </div>
            </div>
            <div class="data_li blank" ref="blank">
            </div>
            <div>
              <div class="data_li">
                <div class="left">1ms</div>
                <span>{{ $t('lanchpad.cont3.text1') }}</span>
              </div>
              <div class="data_li">
                <div class="left">8K</div>
                <span>{{ $t('lanchpad.cont3.text2') }}</span>
              </div>
              <div class="data_li">
                <div class="left">244Hz</div>
                <span>{{ $t('lanchpad.cont3.text3') }}</span>
              </div>
              <div class="data_li">
                <div class="left">24H</div>
                <span>{{ $t('lanchpad.cont3.text4') }}</span>
              </div>
            </div>
            <div class="data_li blank" ref="blank1">
              
            </div>
          </div>
        </div>
        <div class="text_desc">
          <div class="title">{{ $t('lanchpad.cont3.desc1') }}</div>
          <div class="text">{{ $t('lanchpad.cont3.desc2') }}</div>
        </div>
      </div>
      <div class="cont cont16">
        <div class="title">{{ $t('lanchpad.cont16.title1') }}</div>
        <div class="desc">{{ $t('lanchpad.cont16.title2') }}</div>
        <div class="product">
          <div class="pro_cont">
            <div class="title">{{ $t('lanchpad.cont16.text1') }}</div>
            <div class="img"><img src="../assets/cont16_img5.png"/></div> 
            <div class="span">deeplink.cloud</div>
          </div>
          <div class="pro_cont">
            <div class="title">{{ $t('lanchpad.cont16.text2') }}</div>
            <div class="img"><img src="../assets/cont16_img1.png"/></div>
            <div class="span">hycons.cloud</div>
            <div class="img"><img src="../assets/cont16_img5.png"/></div> 
            <div class="span">deeplink.cloud</div>
          </div>
          <div class="pro_cont">
            <div class="title">{{ $t('lanchpad.cont16.text3') }}</div>
            <div class="img"><img src="../assets/cont16_img4.png"/></div>
            <div class="img"><img src="../assets/cont16_img3.png"/></div>
            <div class="img"><img src="../assets/cont16_img2.png"/></div>
            <div class="img"><img src="../assets/cont16_img1.png"/></div>
          </div>
          <div class="pro_cont">
            <div class="title">{{ $t('lanchpad.cont16.text4') }}</div>
            <div class="span">{{ $t('lanchpad.cont16.text5') }}</div>
            <div class="span">{{ $t('lanchpad.cont16.text6') }}</div> 
          </div>
        </div>
      </div>
      <div class="cont cont4">
        <div class="title">{{ $t('lanchpad.cont4.title1') }}</div>
        <div class="desc">{{ $t('lanchpad.cont4.title2') }}</div>
        <div class="inlet show">
          <div class="round">
            <div class="top">{{ $t('lanchpad.cont4.text1_1') }}</div>
            <div class="text text1">{{ $t('lanchpad.cont4.text1_2') }}</div>
          </div>
          <div class="round">
            <div class="top">{{ $t('lanchpad.cont4.text2_1') }}</div>
            <div class="text">{{ $t('lanchpad.cont4.text2_2') }}</div>
          </div>
          <div class="center">
            <div class="block1">{{ $t('lanchpad.cont4.desc1') }}</div>
            <div class="block2">{{ $t('lanchpad.cont4.desc2') }}</div>
            <div class="block3">{{ $t('lanchpad.cont4.desc3') }}</div>
          </div>
          <div class="round">
            <div class="top">{{ $t('lanchpad.cont4.text3_1') }}</div>
            <div class="text">{{ $t('lanchpad.cont4.text3_2') }}</div>
          </div>
          <div class="round">
            <div class="top">{{ $t('lanchpad.cont4.text4_1') }}</div>
            <div class="text">{{ $t('lanchpad.cont4.text4_2') }}</div>
          </div>
        </div>
        <div class="inlet hide">
          <div class="center">
            <div class="block1">{{ $t('lanchpad.cont4.desc1') }}</div>
            <div class="block2">{{ $t('lanchpad.cont4.desc2') }}</div>
            <div class="block3">{{ $t('lanchpad.cont4.desc3') }}</div>
          </div>
          <div class="inletFlex">
            <div class="round">
              <div class="top">{{ $t('lanchpad.cont4.text1_1') }}</div>
              <div class="text text1">{{ $t('lanchpad.cont4.text1_2') }}</div>
            </div>
            <div class="round">
              <div class="top">{{ $t('lanchpad.cont4.text2_1') }}</div>
              <div class="text">{{ $t('lanchpad.cont4.text2_2') }}</div>
            </div>
            <div class="round">
              <div class="top">{{ $t('lanchpad.cont4.text3_1') }}</div>
              <div class="text">{{ $t('lanchpad.cont4.text3_2') }}</div>
            </div>
            <div class="round">
              <div class="top">{{ $t('lanchpad.cont4.text4_1') }}</div>
              <div class="text">{{ $t('lanchpad.cont4.text4_2') }}</div>
            </div>
          </div>
        </div>
        <div class="viewpoint">
          <div class="li" @click="linkHref('https://youtu.be/lO7XVxveGR8')">{{ $t('lanchpad.cont4.btn1') }}</div>
          <div class="li" @click="linkHref('https://youtu.be/6slRE67heX8')">{{ $t('lanchpad.cont4.btn2') }}</div>
          <div class="li" @click="linkHref('https://youtu.be/G9MvdCAsngY')">{{ $t('lanchpad.cont4.btn3') }}</div>
          <div class="li" @click="linkHref('https://youtu.be/dl0C4uAFz0o')">{{ $t('lanchpad.cont4.btn4') }}</div>
        </div>
      </div>
      <div class="cont cont17">
        <div class="title">{{ $t('lanchpad.cont17.title1') }}</div>
        <div class="mode">
          <div class="modetype mode1">
            <div class="title">{{ $t('lanchpad.cont17.text1') }}</div>
            <div class="desc">{{ $t('lanchpad.cont17.desc1') }}</div>
          </div>
          <div class="modetype mode2">
            <div class="title">{{ $t('lanchpad.cont17.text2') }}</div>
            <div class="desc">{{ $t('lanchpad.cont17.desc2') }}</div>
          </div>
        </div>
      </div>
      <div class="cont cont5">
        <div class="title">{{ $t('lanchpad.cont5.title1') }}</div>
        <div class="intro">
          <div class="topcenter">
            <div>{{ $t('lanchpad.cont5.desc1') }}</div>
            <div>
              <p>{{ $t('lanchpad.cont5.desc2_1') }}</p>
              <p>{{ $t('lanchpad.cont5.desc2_2') }}</p>
            </div>
          </div>
          <div class="left">
            <div class="text1">{{ $t('lanchpad.cont5.title2') }}</div>
            <div class="text2">{{ $t('lanchpad.cont5.text2') }}</div>
          </div>
          <div class="right">
            <div class="text1">{{ $t('lanchpad.cont5.title3') }}</div>
            <div class="text2">{{ $t('lanchpad.cont5.text3') }}</div>
          </div>
          <div class="details">{{ $t('lanchpad.cont5.desc3') }}</div>
        </div>
      </div>
      <div class="cont cont6">
        <div class="title">Through blockchain technology</div>
        <div class="title">{{ $t('lanchpad.cont6.title1') }}</div>
        <div class="intro show">
          <div class="intro_li left">
            <div class="left_1">
              <p class="text">{{ $t('lanchpad.cont6.desc1') }}</p>
            </div>
            <div class="left_2">
              <div class="icon icon1"></div>
              <div class="text">{{ $t('lanchpad.cont6.text1') }}</div>
            </div>
          </div>
          <div class="intro_li right">
            <div class="right_2">
              <div class="icon icon2"></div>
              <div class="text">{{ $t('lanchpad.cont6.text2') }}</div>
            </div>
            <div class="right_1">
              <p class="text">{{ $t('lanchpad.cont6.desc2') }}</p>
            </div>
          </div>
          <div class="intro_li left">
            <div class="left_1 lineH1">
              <p class="text">{{ $t('lanchpad.cont6.desc3') }}</p>
            </div>
            <div class="left_2">
              <div class="icon icon6"></div>
              <div class="text">{{ $t('lanchpad.cont6.text3') }}</div>
            </div>
          </div>
          <div class="intro_li right">
            <div class="right_2">
              <div class="icon icon3"></div>
              <div class="text">{{ $t('lanchpad.cont6.text4') }}</div>
            </div>
            <div class="right_1 lineH1">
              <p class="text">{{ $t('lanchpad.cont6.desc4') }}</p>
            </div>
          </div>
          <div class="intro_li left">
            <div class="left_1">
              <p class="text">{{ $t('lanchpad.cont6.desc6') }}</p>
            </div>
            <div class="left_2">
              <div class="icon icon5"></div>
              <div class="text">{{ $t('lanchpad.cont6.text5') }}</div>
            </div>
          </div>
          <div class="intro_li right">
            <div class="right_2">
              <div class="icon icon4"></div>
              <div class="text">{{ $t('lanchpad.cont6.text6') }}</div>
            </div>
            <div class="right_1">
              <p class="text">{{ $t('lanchpad.cont6.desc5') }}</p>
            </div>
          </div>
        </div>
        <div class="intro hide">
          <div class="intro_desc">
            <div class="intro_li left">
              <div class="left_1">
                <p class="text">{{ $t('lanchpad.cont6.desc1') }}</p>
              </div>
              <div class="left_2">
                <div class="icon icon1"></div>
                <div class="text">{{ $t('lanchpad.cont6.text1') }}</div>
              </div>
            </div>
            <div class="point point1"></div>
          </div>
          <div class="intro_desc">
            <div class="intro_li left">
              <div class="left_1 lineH1">
                <p class="text">{{ $t('lanchpad.cont6.desc3') }}</p>
              </div>
              <div class="left_2">
                <div class="icon icon6"></div>
                <div class="text">{{ $t('lanchpad.cont6.text3') }}</div>
              </div>
            </div>
            <div class="point point2"></div>
          </div>
          <div class="intro_desc">
            <div class="intro_li left">
              <div class="left_1">
                <p class="text">{{ $t('lanchpad.cont6.desc6') }}</p>
              </div>
              <div class="left_2">
                <div class="icon icon5"></div>
                <div class="text">{{ $t('lanchpad.cont6.text5') }}</div>
              </div>
            </div>
            <div class="point point3"></div>
          </div>
          <div class="intro_desc">
            <div class="point point1"></div>
            <div class="intro_li right">
              <div class="right_2">
                <div class="icon icon2"></div>
                <div class="text">{{ $t('lanchpad.cont6.text2') }}</div>
              </div>
              <div class="right_1">
                <p class="text">{{ $t('lanchpad.cont6.desc2') }}</p>
              </div>
            </div>
          </div>
          <div class="intro_desc">
            <div class="point point2"></div>
            <div class="intro_li right">
              <div class="right_2">
                <div class="icon icon3"></div>
                <div class="text">{{ $t('lanchpad.cont6.text4') }}</div>
              </div>
              <div class="right_1 lineH1">
                <p class="text">{{ $t('lanchpad.cont6.desc4') }}</p>
              </div>
            </div>
          </div>
          <div class="intro_desc">
            <div class="point point3"></div>
            <div class="intro_li right">
              <div class="right_2">
                <div class="icon icon4"></div>
                <div class="text">{{ $t('lanchpad.cont6.text6') }}</div>
              </div>
              <div class="right_1">
                <p class="text">{{ $t('lanchpad.cont6.desc5') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cont cont7">
        <div class="title">{{ $t('lanchpad.cont7.title1') }}</div>
        <div class="desc">{{ $t('lanchpad.cont7.desc1') }}</div>
        <div class="intro">
          <div class="icon icon1"></div>
          <div class="icon icon2"></div>
          <div class="left">
            <div class="top_text">{{ $t('lanchpad.cont7.title2') }}</div>
            <p class="text">{{ $t('lanchpad.cont7.text1') }}</p>
            <p class="text">{{ $t('lanchpad.cont7.text2') }}</p>
            <p class="text">{{ $t('lanchpad.cont7.text3') }}</p>
          </div>
          <div class="right">
            <div class="top_text">{{ $t('lanchpad.cont7.title3') }}</div>
            <p class="text">{{ $t('lanchpad.cont7.text4') }}</p>
            <p class="text">{{ $t('lanchpad.cont7.text5') }}</p>
            <p class="text">{{ $t('lanchpad.cont7.text6') }}</p>
          </div>
        </div>
      </div>
      <div class="cont cont8">
        <div class="title">{{ $t('lanchpad.cont8.title1') }}</div>
        <div class="icon"></div>
        <div class="intro">
          <div class="ele1 line_text">{{ $t('lanchpad.cont8.text1') }}</div>
          <div class="ele2 line_text">{{ $t('lanchpad.cont8.text2') }}</div>
          <div class="ele3 line_text">{{ $t('lanchpad.cont8.text3') }}</div>
          <div class="ele4 line_text">{{ $t('lanchpad.cont8.text4') }}</div>
          <div class="ele5 line_text">{{ $t('lanchpad.cont8.text5') }}</div>
          <div class="ele6 line_text">{{ $t('lanchpad.cont8.text6') }}</div>
          <div class="ele7">
            <div class="icon1"></div>
            <div class="text">{{ $t('lanchpad.cont8.text7') }}</div>
          </div>
          <div class="ele8">
            <div class="text">{{ $t('lanchpad.cont8.text8') }}</div>
            <div class="text1">{{ $t('lanchpad.cont8.text9') }}</div>
            <div class="list">
              <p>{{ $t('lanchpad.cont8.text10') }}</p>
              <p>{{ $t('lanchpad.cont8.text11') }}</p>
              <p>{{ $t('lanchpad.cont8.text12') }}</p>
              <p>{{ $t('lanchpad.cont8.text13') }}</p>
            </div>
          </div>
          <div class="ele9">
            <div class="text">{{ $t('lanchpad.cont8.text8') }}</div>
            <div class="text1">{{ $t('lanchpad.cont8.text14') }}</div>
            <div class="buy">{{ $t('lanchpad.cont8.text15') }}</div>
          </div>
          <div class="ele10">
            <div class="text">{{ $t('lanchpad.cont8.text16') }}</div>
            <div class="text1">{{ $t('lanchpad.cont8.text17') }}</div>
          </div>
          <div class="ele11">
            <div class="icon1"></div>
            <div class="text">{{ $t('lanchpad.cont8.text18') }}</div>
          </div>
          <div class="ele12">
            <div class="text">{{ $t('lanchpad.cont8.text19') }}</div>
            <div class="text1">{{ $t('lanchpad.cont8.text20') }}</div>
          </div>
        </div>
      </div>
      <div class="cont cont9">
        <div class="title">{{ $t('lanchpad.cont9.title1') }}</div>
        <div class="intro">
          <div class="left"></div>
          <div class="right">
            <div class="topcont">
              <div class="user">
                <div class="icon1"></div>
                <div class="text">{{ $t('lanchpad.cont9.text1') }}</div>
              </div>
              <div class="text_line">{{ $t('lanchpad.cont9.text2') }}<span class="arrow"></span></div>
              <div class="block">
                <div class="text">{{ $t('lanchpad.cont9.text3') }}</div>
                <div class="text1">{{ $t('lanchpad.cont9.text4') }}</div>
              </div>
            </div>
            <div class="list">
              <div class="li">
                <div class="num">01</div>
                <div class="text">{{ $t('lanchpad.cont9.text5') }}</div>
              </div>
              <div class="li">
                <div class="num">02</div>
                <div class="text">{{ $t('lanchpad.cont9.text6') }}</div>
              </div>
              <div class="li">
                <div class="num">03</div>
                <div class="text">{{ $t('lanchpad.cont9.text7') }}</div>
              </div>
              <div class="li">
                <div class="num">04</div>
                <div class="text">{{ $t('lanchpad.cont9.text8') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cont cont10">
        <div class="title">{{ $t('lanchpad.cont10.title') }}</div>
        <div class="intro show">
          <div class="left_li">
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc1') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text1') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc2') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text2') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc11') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text11') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc4') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text4') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc5') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text5') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc6') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text6') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc7') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text7') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc8') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text8') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc9') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text9') }}</div>
            </div>
          </div>
          <div class="line1"><img src="../assets/line1.svg" alt=""></div>
          <div class="right_li">
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc10') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text10') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc3') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text3') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc12') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text12') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc13') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text13') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc14') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text14') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc15') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text15') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc16') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text16') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc17') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text17') }}</div>
            </div>
          </div>
        </div>
        <div class="intro hide">
          <div class="line1"></div>
          <div class="list">
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc1') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text1') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc10') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text10') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc2') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text2') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc11') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text11') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc3') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text3') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc12') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text12') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc4') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text4') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc13') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text13') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc5') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text5') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc14') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text14') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc6') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text6') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc15') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text15') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc7') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text7') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc16') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text16') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc8') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text8') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc17') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text17') }}</div>
            </div>
            <div class="li">
              <div class="li_title">{{ $t('lanchpad.cont10.desc9') }}</div>
              <div class="li_text">{{ $t('lanchpad.cont10.text9') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="cont cont11">
        <div class="title">{{ $t('lanchpad.cont11.title') }}</div>
        <div class="intro">
          <div class="userimg"></div>
          <div class="scan" :class="{active: scanShow}"></div>
          <div class="scan1"></div>
          <div class="datalist">
            <div class="datali">
              <div class="point"></div>
              <div class="data">
                <div class="top">{{ $t('lanchpad.cont11.desc1') }}</div>
                <div class="text">{{ $t('lanchpad.cont11.text1') }}</div>
              </div>
            </div>
            <div class="datali">
              <div class="point"></div>
              <div class="data">
                <div class="top">{{ $t('lanchpad.cont11.desc2') }}</div>
                <div class="text">{{ $t('lanchpad.cont11.text2') }}</div>
              </div>
            </div>
            <div class="datali">
              <div class="point"></div>
              <div class="data">
                <div class="top">{{ $t('lanchpad.cont11.desc3') }}</div>
                <div class="text">{{ $t('lanchpad.cont11.text3') }}</div>
              </div>
            </div>
            <div class="datali">
              <div class="point"></div>
              <div class="data">
                <div class="top">{{ $t('lanchpad.cont11.desc4') }}</div>
                <div class="text">{{ $t('lanchpad.cont11.text4') }}</div>
              </div>
            </div>
            <div class="datali">
              <div class="point"></div>
              <div class="data">
                <div class="top">{{ $t('lanchpad.cont11.desc5') }}</div>
                <div class="text">{{ $t('lanchpad.cont11.text5') }}</div>
              </div>
            </div>
            <div class="datali">
              <div class="point"></div>
              <div class="data">
                <div class="top">{{ $t('lanchpad.cont11.desc6') }}</div>
                <div class="text">{{ $t('lanchpad.cont11.text6') }}</div>
              </div>
            </div>
            <div class="datali">
              <div class="point"></div>
              <div class="data">
                <div class="top">{{ $t('lanchpad.cont11.desc7') }}</div>
                <div class="text">{{ $t('lanchpad.cont11.text7') }}</div>
              </div>
            </div>
            <div class="datali">
              <div class="point"></div>
              <div class="data">
                <div class="top">{{ $t('lanchpad.cont11.desc8') }}</div>
                <div class="text">{{ $t('lanchpad.cont11.text8') }}</div>
              </div>
            </div>
            <div class="datali">
              <div class="point"></div>
              <div class="data">
                <div class="top">{{ $t('lanchpad.cont11.desc9') }}</div>
                <div class="text">{{ $t('lanchpad.cont11.text9') }}</div>
              </div>
            </div>
            <div class="datali">
              <div class="point"></div>
              <div class="data">
                <div class="top">{{ $t('lanchpad.cont11.desc10') }}</div>
                <div class="text">{{ $t('lanchpad.cont11.text10') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cont cont12">
        <div class="intro">
          <div class="echarDom" ref="EcharRef"></div>
          <div class="details Total" v-if="!showDraw">
            <div class="title">Total</div>
            <div class="block">
              <div class="text">Quantity (billion)：</div>
              <div class="desc">100 billion</div>
            </div>
            <!-- <div class="block">
              <div class="text">Not in circulation (billion) ：</div>
              <div class="desc">100 billion</div>
            </div> -->
            <div class="block">
              <div class="text">Description：</div>
              <div class="desc">{{ $t('lanchpad.cont12.text') }}</div>
            </div>
          </div>
          <div class="details Single" :class="{ font12: drawData.datalist && drawData.datalist.length }" v-else>
            <div class="title">{{ drawData.name }}</div>
            <div class="dataList" v-if="drawData.datalist && drawData.datalist.length" v-for="(item, index) in drawData.datalist">
              <div class="data_top"><span></span> {{ $t('lanchpad.cont12.text1') }} - {{ item.name }}: {{ item.quantity }}%</div>
              <div class="text"><span>Quantity (billion) ：</span> {{ item.quantity }} </div>
              <div class="text"><span>In circulation (billion) ：</span> 0 </div>
              <div class="text"><span>Not in circulation (billion) ：</span> {{ item.quantity }} </div>
              <div class="text"><span>Description ：</span> {{ item.desc }} </div>
            </div>
            <div class="dataList" v-else>
              <div class="text"><span>Quantity (billion) ：</span> {{ drawData.value }} </div>
              <div class="text"><span>In circulation (billion) ：</span> 0 </div>
              <div class="text"><span>Not in circulation (billion) ：</span> {{ drawData.value }} </div>
              <div class="text"><span>Description ：</span> {{ drawData.desc }} </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cont cont13">
        <div class="title">{{ $t('lanchpad.cont13.title') }}</div>
        <div class="teamlist">
          <div class="teamli" @mouseover="showInfo(1)" @mouseout="showdetail = false">
            <div class="userimg"><img src="../assets/lanch_cont13img1.png" alt=""></div>
            <div class="name">YONG HE</div>
          </div>
          <div class="teamli" @mouseover="showInfo(2)" @mouseout="showdetail = false">
            <div class="userimg"><img src="../assets/lanch_cont13img4.jpg" alt=""></div>
            <div class="name">GUANGHUI LUO</div>
          </div>
          <div class="teamli" @mouseover="showInfo(3)" @mouseout="showdetail = false">
            <div class="userimg"><img src="../assets/lanch_cont13img2.png" alt=""></div>
            <div class="name">PARK JI HYE</div>
          </div>
          <div class="teamli" @mouseover="showInfo(4)" @mouseout="showdetail = false">
            <div class="userimg"><img src="../assets/lanch_cont13img3.png" alt=""></div>
            <div class="name">VARUN</div>
          </div>
          <div class="teamli" @mouseover="showInfo(5)" @mouseout="showdetail = false">
            <div class="userimg"><img src="../assets/lanch_cont13img5.png" alt=""></div>
            <div class="name">Mr. YANG</div>
          </div>
          <div class="teamli" @mouseover="showInfo(6)" @mouseout="showdetail = false">
            <div class="userimg"><img src="../assets/lanch_cont13img6.jpg" alt=""></div>
            <div class="name">DEREK PARK</div>
          </div>
          <div class="teamli" @mouseover="showInfo(7)" @mouseout="showdetail = false">
            <div class="userimg"><img src="../assets/lanch_cont13img7.png" alt=""></div>
            <div class="name">Joseph Alexander</div>
          </div>
        </div>
        <div v-if="showdetail" class="detailsInfo show" :class="{ top1: (showIndex > 4)}">
          <div class="name">{{ userInfo[showIndex].name }}</div>
          <div class="synopsis">{{ userInfo[showIndex].intro }}</div>
          <div class="text" v-for="(item, index) in userInfo[showIndex].experience" :key="index">{{ item }} </div>
        </div>
        <div v-if="showdetail" class="detailsInfo hide" :class="{ top1: (showIndex > 3 && showIndex <= 6), top2: (showIndex > 6)}">
          <div class="name">{{ userInfo[showIndex].name }}</div>
          <div class="synopsis">{{ userInfo[showIndex].intro }}</div>
          <div class="text" v-for="(item, index) in userInfo[showIndex].experience" :key="index">{{ item }} </div>
        </div>
      </div>
      <div class="cont cont14">
        <div class="title">{{ $t('lanchpad.cont14.title') }}</div>
        <div class="organList">
          <img @mouseover="showInfo1(0)" @mouseout="organdetail = false" src="../assets/lanch_cont14img1.png" alt="">
          <img @mouseover="showInfo1(1)" @mouseout="organdetail = false" src="../assets/lanch_cont14img2.png" alt="">
          <img @mouseover="showInfo1(2)" @mouseout="organdetail = false" src="../assets/lanch_cont14img3.png" alt="">
          <img @mouseover="showInfo1(3)" @mouseout="organdetail = false" src="../assets/lanch_cont14img4.png" alt="">
        </div>
        <div v-if="organdetail" class="organInfo">{{ organInfo[organIndex] }}</div>
      </div>
      <div class="cont cont15">
        <div class="title">{{ $t('lanchpad.cont15.title') }}</div>
        <div class="communityList hide">
          <div class="list"  @scroll.passive="handleScroll1" ref="progressList">
            <div class="community" @click="linkHref('https://twitter.com/DeepLinkGlobal/status/1666819765401456645?s=20')">
              <div class="act_img">
                <img src="../assets/lanch_cont15img1.png" alt="">
              </div>
              <div class="act_name">{{ $t('lanchpad.cont15.name1') }}</div>
              <div class="act_time">08/06 2023</div>
            </div>
            <div class="community" @click="linkHref('https://twitter.com/DeepLinkGlobal/status/1655215428111855616?s=20')">
              <div class="act_img">
                <img src="../assets/lanch_cont15img2.png" alt="">
              </div>
              <div class="act_name">{{ $t('lanchpad.cont15.name2') }}</div>
              <div class="act_time">07/05 2023</div>
            </div>
            <div class="community" @click="linkHref('https://twitter.com/deepbrainfeng/status/1647529443945226241?s=20')">
              <div class="act_img">
                <img src="../assets/lanch_cont15img3.png" alt="">
              </div>
              <div class="act_name">{{ $t('lanchpad.cont15.name3') }}</div>
              <div class="act_time">13/04 2023</div>
            </div>
            <div class="community" @click="linkHref('https://twitter.com/DeepLinkGlobal/status/1645438888696061961?s=20')">
              <div class="act_img">
                <img src="../assets/lanch_cont15img4.png" alt="">
              </div>
              <div class="act_name">{{ $t('lanchpad.cont15.name4') }}</div>
              <div class="act_time">10/04 2023</div>
            </div>
            <div class="community" @click="linkHref('https://twitter.com/DeepLinkGlobal/status/1638801572325982211?s=20')">
              <div class="act_img">
                <img src="../assets/lanch_cont15img5.png" alt="">
              </div>
              <div class="act_name">{{ $t('lanchpad.cont15.name5') }}</div>
              <div class="act_time">23/03 2023</div>
            </div>
            <div class="community" @click="linkHref('https://twitter.com/DeepLinkGlobal/status/1638800911022604288?s=20')">
              <div class="act_img">
                <img src="../assets/lanch_cont15img6.png" alt="">
              </div>
              <div class="act_name">{{ $t('lanchpad.cont15.name6') }}</div>
              <div class="act_time">22/03 2023</div>
            </div>
            <div class="community" @click="linkHref('https://twitter.com/DeepLinkGlobal/status/1636052278850338849?s=20')">
              <div class="act_img">
                <img src="../assets/lanch_cont15img7.png" alt="">
              </div>
              <div class="act_name">{{ $t('lanchpad.cont15.name7') }}</div>
              <div class="act_time">16/03 2023</div>
            </div>
            <div class="community" @click="linkHref('https://twitter.com/deepbrainfeng/status/1626592760806670340?s=20')">
              <div class="act_img">
                <img src="../assets/lanch_cont15img8.png" alt="">
              </div>
              <div class="act_name">{{ $t('lanchpad.cont15.name8') }}</div>
              <div class="act_time">17/02 2023</div>
            </div>
            <div class="community" @click="linkHref('https://twitter.com/deepbrainfeng/status/1615370872252137473?s=20')">
              <div class="act_img">
                <img src="../assets/lanch_cont15img9.png" alt="">
              </div>
              <div class="act_name">{{ $t('lanchpad.cont15.name9') }}</div>
              <div class="act_time">17/01 2023</div>
            </div>
          </div>
          <div class="progress"><div class="scrollBar" ref="scrollBar"></div>></div>
        </div>
        <div class="communityList show">
          <div class="community" @click="linkHref('https://twitter.com/DeepLinkGlobal/status/1666819765401456645?s=20')">
            <div class="act_img">
              <img src="../assets/lanch_cont15img1.png" alt="">
            </div>
            <div class="act_name">{{ $t('lanchpad.cont15.name1') }}</div>
            <div class="act_time">08/06 2023</div>
          </div>
          <div class="community" @click="linkHref('https://twitter.com/DeepLinkGlobal/status/1655215428111855616?s=20')">
            <div class="act_img">
              <img src="../assets/lanch_cont15img2.png" alt="">
            </div>
            <div class="act_name">{{ $t('lanchpad.cont15.name2') }}</div>
            <div class="act_time">07/05 2023</div>
          </div>
          <div class="community" @click="linkHref('https://twitter.com/deepbrainfeng/status/1647529443945226241?s=20')">
            <div class="act_img">
              <img src="../assets/lanch_cont15img3.png" alt="">
            </div>
            <div class="act_name">{{ $t('lanchpad.cont15.name3') }}</div>
            <div class="act_time">13/04 2023</div>
          </div>
          <div class="community" @click="linkHref('https://twitter.com/DeepLinkGlobal/status/1645438888696061961?s=20')">
            <div class="act_img">
              <img src="../assets/lanch_cont15img4.png" alt="">
            </div>
            <div class="act_name">{{ $t('lanchpad.cont15.name4') }}</div>
            <div class="act_time">10/04 2023</div>
          </div>
          <div class="community" @click="linkHref('https://twitter.com/DeepLinkGlobal/status/1638801572325982211?s=20')">
            <div class="act_img">
              <img src="../assets/lanch_cont15img5.png" alt="">
            </div>
            <div class="act_name">{{ $t('lanchpad.cont15.name5') }}</div>
            <div class="act_time">23/03 2023</div>
          </div>
          <div class="community" @click="linkHref('https://twitter.com/DeepLinkGlobal/status/1638800911022604288?s=20')">
            <div class="act_img">
              <img src="../assets/lanch_cont15img6.png" alt="">
            </div>
            <div class="act_name">{{ $t('lanchpad.cont15.name6') }}</div>
            <div class="act_time">22/03 2023</div>
          </div>
          <div class="community" @click="linkHref('https://twitter.com/DeepLinkGlobal/status/1636052278850338849?s=20')">
            <div class="act_img">
              <img src="../assets/lanch_cont15img7.png" alt="">
            </div>
            <div class="act_name">{{ $t('lanchpad.cont15.name7') }}</div>
            <div class="act_time">16/03 2023</div>
          </div>
          <div class="community" @click="linkHref('https://twitter.com/deepbrainfeng/status/1626592760806670340?s=20')">
            <div class="act_img">
              <img src="../assets/lanch_cont15img8.png" alt="">
            </div>
            <div class="act_name">{{ $t('lanchpad.cont15.name8') }}</div>
            <div class="act_time">17/02 2023</div>
          </div>
          <div class="community" @click="linkHref('https://twitter.com/deepbrainfeng/status/1615370872252137473?s=20')">
            <div class="act_img">
              <img src="../assets/lanch_cont15img9.png" alt="">
            </div>
            <div class="act_name">{{ $t('lanchpad.cont15.name9') }}</div>
            <div class="act_time">17/01 2023</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-model="dialogTableVisible" @opened="openDialog" @closed="closeDialog" :lock-scroll="false" :modal="false" title="DeepLink video" :close-on-click-modal="false" width="45%" draggable>
      <div class="dialogVideo">
        <video ref="videoRef" src="https://download.deeplink.cloud/vedio.mp4"
          loop="loop" 
          autoplay
          controls="controls"
          controlsList="noplaybackrate, nopip">
        </video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { defineComponent, computed, ref, onBeforeMount, onBeforeUnmount, onMounted, getCurrentInstance, watch } from "vue";
  import { useI18n } from "vue-i18n";
  import { useStore } from "vuex"
  import * as echarts from 'echarts';
  export default defineComponent({
    name: 'Lanchpad',
    setup() {
      const store = useStore()
      let lan = computed(() => {
        return store.state.lan
      })
      const { t, locale } = useI18n();
      const instance = getCurrentInstance()
      const timer = ref(null)
      const box = ref('')
      const CurrentHeight = ref(0)
      const scanShow = ref(false)
      const options = ref({
        legend: {
          // top: '5%',
          bottom: '5%',
          left: 'center'
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 30,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 15, name: t('lanchpad.cont12.text2'), desc: t('lanchpad.cont12.desc2') },
              { value: 30, name: t('lanchpad.cont12.text1') , 
                datalist: [
                  { name: t('lanchpad.cont12.text1_1'), quantity: '10', desc: t('lanchpad.cont12.desc1_1') },
                  { name: t('lanchpad.cont12.text1_2'), quantity: '10', desc: t('lanchpad.cont12.desc1_2') },
                  { name: t('lanchpad.cont12.text1_3'), quantity: '5', desc: t('lanchpad.cont12.desc1_3') },
                  { name: t('lanchpad.cont12.text1_4'), quantity: '5', desc: t('lanchpad.cont12.desc1_4') },
                ]
              },
              { value: 12, name: t('lanchpad.cont12.text3'), desc: t('lanchpad.cont12.desc3') },
              { value: 5, name: t('lanchpad.cont12.text4'), desc: t('lanchpad.cont12.desc4') },
              { value: 25, name: t('lanchpad.cont12.text5'), desc: t('lanchpad.cont12.desc5') },
              { value: 10, name: t('lanchpad.cont12.text6'), desc: t('lanchpad.cont12.desc6') },
              { value: 3, name: t('lanchpad.cont12.text7'), desc: t('lanchpad.cont12.desc7') }
            ]
          }
        ]
      })
      const showDraw = ref(false)
      const drawData = ref(null)
      const userInfo = ref({
        1: { 
          name: 'HE YONG', 
          intro: 'Founder of DeepLink and DeepBrainChain', 
          experience: [
            'Serial entrepreneur with 13 years of experience in AI, 7 years in blockchain and distributed computing network technology development.',
            "Graduated with a Bachelor's degree in Computer Science from China Ocean University in 2008.",
            "In 2012, he founded Jushang Intelligent and developed the world's first Chinese AI voice assistant called 'Intelligent 360.'",
            "Within three years, the software had over 17 million downloads. In 2014, he launched the world's first AI speaker, 'Xiao Zhi Speaker.'",
            'In May 2017, he founded DeepBrainChain, serving hundreds of AI, cloud gaming, and cloud internet cafe clients.'
          ]
        },
        2: { 
          name: 'LUO GUANGHUI', 
          intro: 'Co-founder of DeepLink', 
          experience: [
            'Serial entrepreneur, and senior cloud gaming expert. Former Dean of Shunwang Cloud Gaming Research Institute, responsible for technical research and development.',
            "Graduated with a Bachelor's degree in Computer Science from Zhejiang University in 1999. From 2001 to 2004, he worked at Zhejiang Lande, involved in telecommunications-related work.",
            "In 2009, he founded China's first dual-core browser, 'Sunflower Browser.'",
            "From 2010 to 2021, he joined the listed company Shunwang and founded Shunwang Cloud Computer, serving as the Dean of Shunwang Research Institute. He provided cloud internet cafe solutions and operated cloud gaming, making his company the first in China to offer cloud gaming solutions."
          ]
        },
        3: { 
          name: 'PARK JI HYE', 
          intro: 'DeepLink CSO', 
          experience: [
            'Education: 2007 Peking University, Department of Chinese',
            "2023: DeepLink CSO",
            "2022-2023: DeepBrain Chain Chief Director",
            "2019-2021: CELLOGIN Overseas Market Leader",
            "2018: FLOW FACTORY CEO"
          ]
        },
        4: { 
          name: 'VARUN', 
          intro: 'DeepLink India Market Leader', 
          experience: [
            'Education and Certifications: - Bachelor of Business Administration degree earned in 2020 in University of Mysore.',
            "- Certification in digital marketing.",
            "- Certification in SEO.",
            "- Certification in blockchain.",
            "Sales and Marketing at Technic Constructions: - Sales and Marketing role held in 2019, achieving $500k in sales within a three-month period.",
            "Business Development Associate at BYJU'S: - Employed from 2020 to 2021.",
            "- Played a key role in driving growth, forging partnerships, and streamlining operations for educational technology initiatives at a unicorn startup valued at $10 billion.",
            "Co-founder of Space Inn: - Co-founded an independent project focused on developing entrepreneurial skills, strategic thinking, and business acumen.",
            "Stock Market Investing/Trading: - Accumulated five years of experience in stock market investing and trading, demonstrating expertise in navigating financial markets and capitalizing on investment opportunities.",
            "Internships in Corporate Companies: - Completed multiple internships in corporate companies, gaining valuable insights into corporate culture, efficient processes, and effective business strategies.",
            "Crypto Industry Experience: - Worked on multiple crypto and NFT projects, gaining valuable industry experience.",
            "- Contributed to Empowa, a prominent Real-Fi Cardano project, driving its development and growth. Empowa, a Cardano project in 2022, contributing to its growth.",
            "- Currently working with DeepLink Cloud, expanding expertise in the crypto space."
          ]
        },
        5: { 
          name: 'Mr. YANG', 
          intro: 'Advisor', 
          experience: [
            'Working as Vice President at Hyunjin ICT, an IoT and communication service company since 2012, for 11 years. ',
            "Sales and marketing management, experience in performing multiple large-scale projects in public institutions.",
            "Information strategy consulting, Business innovation project, and SW development at Samsung SDS, the largest IT company in Korea, for 14 years (1998~2012). ",
            "Worked for 3 years (2017~2019) as a strategic planning executive at Coinzest, a cryptocurrency exchange with experience of being ranked 1st in Korea and 10th globally. ",
            "The founder of Hyunjin Venus, which operates welfare shopping malls for large Korean corporations and public institutions, and has operated the business for 5 years.",
            'Qualified PMP (Project Management Professional) and CISA (Certified Information Systems Auditor).'
          ]
        },
        6: { 
          name: 'DEREK PARK', 
          intro: 'Advisor', 
          experience: [
            'Education: 2003 Guanghua School of Management, Peking University',
            "2023: MetABC CEO",
            "2020: HillstoneHub CEO",
            "2019: Hillstone Business Center CEO",
            "2019: Hillstone Global (blockchain) COO",
            "2017: Foundersbridge Founder",
            "2017: Hillstone Partners (Private Equity) Partner",
            "2014: BrightA Consulting Co-founder ",
            "2012: Senior Consultant (Chinese Business Expert)"
          ]
        },
        7: { 
          name: 'Joseph Alexander', 
          intro: 'Advisor', 
          experience: [
            "Joseph Alexander is the creator of ChatDBC.com, Deep Brain Chain's custom large language model.",
            'His speciality is North American business development for DeepLink and DBC.' ,
            'You can follow @ChatDBC on Twitter to stay informed on all DeepLink and DBC news.'
          ]
        }
      })
      const showIndex = ref(1)
      const showdetail = ref(false)
      const showInfo = (el) => {
        showIndex.value = el
        showdetail.value = true
      }
      const organInfo = ref([
        'DeepBrain Chain Foundation was established in 2017. In January 2018, DBC Token was listed on Huobi Exchange. The main network will be launched in 2021. DeepBrain Chain is a high-performance distributed computing power network with GPU as the core. The vision is based on blockchain technology Construct a distributed high-performance computing power network with unlimited expansion, and become the most important computing power infrastructure in the era of AI+Metaverse. It mainly provides GPU computing services for artificial intelligence, cloud games, movie rendering and other fields. At present, it has served hundreds of artificial intelligence and cloud game-related companies and more than 30,000 AI practitioners.',
        "Gobi Partners is a professional venture capital firm with offices in Shanghai, Beijing, and Southeast Asia. They specialize in investing in early-stage technology projects in China. Gobi Fund's strategic investors include IBM, Sierra Ventures, The McGraw-Hill Companies, and Steamboat Ventures (Disney's venture capital division). They have previously invested in well-known startups such as Tuniu, Camera360, and Zhuyun. Gobi Partners is an established investment fund in the industry.",
        "Hycons is a GPU computing cloud platform based on DBC technology developed by Hyunjin ICT. Hycons stands out with its DBC-based distributed high-performance network technology and DeepLink-based lag-free HD streaming technology. The platform provides comprehensive services such as membership management, registration and payment for different service types such as enterprises, schools, research institutions and franchisees. Currently, more than 1,000 GPU cards and 2 centers are in operation in Korea, and it is planned to expand to 5 centers in the future. In addition, Hycons is testing it by applying it to the franchise business of Internet cafes. With advanced technology foundation, competitive cloud service rates and automated service capabilities, Hycons aims to become the world's leading GPU computing platform.",
        "ROCK Capital is a specialized cryptocurrency fund company founded in Korea in 2018, bringing together professional resources in finance and investment, as well as blockchain and decentralization experts. With extensive collaboration with various domestic and international businesses, global projects, governments, institutions, and other economic entities, ROCK have successfully executed over 100 projects, pioneering diverse areas of future finance. Through strengthened collaboration, growth, activation, and partnerships, ROCK possesses rich experience and expertise in diverse market environments. Upholding unwavering principles like a rock, ROCK strive to generate high returns, expand investment opportunities, and maximize capital activities, creating concrete customer experiences."
      ])
      const organIndex = ref(1)
      const organdetail = ref(false)
      const showInfo1 = (el) => {
        organIndex.value = el
        organdetail.value = true
      }

      const dialogTableVisible = ref(false)
      const openDialog = () => {
        instance.refs.videoRef.play()
      }
      const closeDialog = () => {
        instance.refs.videoRef.pause()
      }
      const drawChart = () => {
        const chart = echarts.init(instance.refs.EcharRef, null, { renderer: 'svg' })
        chart.setOption(options.value);
        chart.on('mouseover', function (params) {
          drawData.value = params.data
          showDraw.value = true
        });
        chart.on('mouseout', function (params) {
          showDraw.value = false
        });
      }
      const init = () => {
        if (instance.refs.warp_cont.clientWidth <= instance.refs.wrapper.clientWidth) {
          instance.refs.blank.style.width = instance.refs.wrapper.clientWidth - instance.refs.warp_cont.clientWidth + 10 + 'px'
          instance.refs.blank1.style.width = instance.refs.wrapper.clientWidth - instance.refs.warp_cont.clientWidth + 10 + 'px'
        }
        box.value = instance.refs.wrapper;
        timer.value = setInterval(() => {
          move();
        }, 1);
      }
      const move = () => {
        let curLeft = box.value.scrollLeft;
        let scrollWidth = instance.refs.marquee.scrollWidth / 2 + 50;
        box.value.scrollLeft = curLeft + 1;
        if (curLeft > scrollWidth) {
          box.value.scrollLeft = 0;
        }
      }
      //鼠标悬停
      const mouseover = () => {
        clearInterval(timer.value);
        timer.value = null;
      }
      //鼠标离开，继续滚动
      const mouseout = () => {
        init();
      }
      const pointList = ref([
        { top: '2740', active: false },
        { top: '2910', active: false },
        { top: '4050', active: false },
        { top: '4320', active: false },
        { top: '4460', active: false },
        { top: '4600', active: false },
        { top: '5035', active: false },
        { top: '5345', active: false },
        { top: '5885', active: false },
        { top: '6050', active: false },
        { top: '6400', active: false },
        { top: '6625', active: false },
        { top: '6700', active: false },
        { top: '6795', active: false, samll: true },
        { top: '6880', active: false, samll: true },
        { top: '6950', active: false, samll: true },
        { top: '7040', active: false, samll: true },
        { top: '7125', active: false, samll: true },
        { top: '7165', active: false, samll: true },
        { top: '7220', active: false, samll: true },
        { top: '7255', active: false, samll: true },
        { top: '7310', active: false, samll: true },
        { top: '7400', active: false }
      ])
      const downLoad = (el) => {
        if (el == 'white') {
          window.open('https://www.deeplink.cloud/DeepLink_Whitepaper.pdf', 'target')
        } else {
          window.open('https://www.deeplink.cloud/DeepLink_Protocol.pdf', 'target')
        }
      }
      const linkHref = (el) => {
        window.open(el, 'target')
      }
      const progressList = ref(null)
      const handleScroll = () => {
        CurrentHeight.value = document.body.scrollTop || document.documentElement.scrollTop
        if (CurrentHeight.value - 1800 + window.innerHeight > 0) {
          pointList.value.map((el, index) => {
            if (CurrentHeight.value + window.innerHeight/1.5 > Number(el.top)) {
              el.active = true
              instance.refs.lineRef.style.height = el.top - 2700 + 'px'
            } else {
              el.active = false
            }
          })
        }
        if (CurrentHeight.value > 6550) {
          scanShow.value = true
        } else {
          scanShow.value = false
        }
      }
      const handleScroll1 = () => {
        instance.refs.scrollBar.style.left = `${instance.refs.progressList.scrollLeft / 35 }%`
      }
      onMounted(() => {
        init()
        drawChart()
        window.addEventListener('scroll', handleScroll)
        progressList.value = instance.refs.progressList
      })
      onBeforeUnmount(() => {
        window.removeEventListener('scroll', handleScroll)
        clearInterval(timer.value);
        timer.value = null;
      })
      return {
        lan,
        scanShow,
        showDraw,
        drawData,
        pointList,
        userInfo,
        showIndex,
        showdetail,
        dialogTableVisible,
        openDialog,
        closeDialog,
        showInfo,
        organInfo,
        organIndex,
        organdetail,
        showInfo1,
        mouseover,
        mouseout,
        handleScroll,
        handleScroll1,
        linkHref,
        downLoad
      };
    }
  })
</script> 

<style lang="scss" scoped>
.Lanchpad {
  width: 100%;
  font-style: normal;
  font-family: MiSans;
  .content {
    width: 100%;
    font-size: 0;
    line-height: 0;
    min-width: 1200px;
    position: relative;
    &.content1 {
      width: 100%;
      height: 10720px;
      overflow: hidden;
      background: url("../assets/lanchpadbg.png") no-repeat center;
      background-size: 100% 10720px;
    }
    .bg1 {
      position: absolute;
      top: -250px;
      left: -150px;
      width: 750px;
      height: 750px;
      background: url(../assets/lanch_bg1.png) no-repeat 100%/100%;
    }
    .bg2 {
      position: absolute;
      z-index: 11;
      top: -100px;
      right: -100px;
      width: 400px;
      height: 400px;
      background: url(../assets/lanch_bg2.png) no-repeat 100%/100%;
    }
    .bg3 {
      position: absolute;
      z-index: 1;
      top: 1300px;
      right: -300px;
      width: 720px;
      height: 720px;
      animation: spin 10s linear infinite;
      background: url(../assets/lanch_bg3.png) no-repeat 100%/100%;
    }
    .bg4 {
      z-index: 11;
      position: absolute;
      top: 6320px;
      right: 120px;
      width: 410px;
      height: 410px;
      background: url(../assets/lanch_bg4.png) no-repeat 100%/100%;
    }
    .bg5 {
      z-index: 11;
      position: absolute;
      top: 2100px;
      right: -180px;
      width: 380px;
      height: 380px;
      animation: shake2 10s linear infinite;
      background: url(../assets/lanch_iocn9.png) no-repeat 100%/100%;
    }
    .bg6 {
      z-index: 11;
      position: absolute;
      top: 3100px;
      left: -120px;
      width: 300px;
      height: 300px;
      animation: shake2 6s linear infinite;
      background: url(../assets/lanch_iocn7.png) no-repeat 100%/100%;
    }
    
    .bg7 {
      z-index: 1;
      position: absolute;
      top: 5400px;
      left: -100px;
      width: 280px;
      height: 280px;
      animation: shake2 8s linear infinite;
      background: url(../assets/lanch_iocn4.png) no-repeat 100%/100%;
    }
    
    .bg8 {
      z-index: 11;
      position: absolute;
      top: 3900px;
      right: -100px;
      width: 240px;
      height: 240px;
      animation: shake2 12s linear infinite;
      background: url(../assets/lanch_iocn5.png) no-repeat 100%/100%;
    }
    
    .bg9 {
      z-index: 11;
      position: absolute;
      top: 5400px;
      left: -120px;
      width: 300px;
      height: 300px;
      animation: shake2 20s linear infinite;
      background: url(../assets/lanch_iocn6.png) no-repeat 100%/100%;
    }
    .bg10 {
      z-index: 11;
      position: absolute;
      top: 8230px;
      right: 0;
      width: 286px;
      height: 466px;
      background: url(../assets/lanch_iocn10.png) no-repeat 100%/100%;
    }
    .bg11 {
      z-index: 11;
      position: absolute;
      top: 9280px;
      left: -120px;
      width: 304px;
      height: 304px;
      animation: shake2 15s linear infinite;
      background: url(../assets/lanch_iocn8.png) no-repeat 100%/100%;
    }


    .line {
      position: absolute;
      z-index: 5;
      width: 228px;
      top: 2750px;
      left: 0;
      right: 0;
      margin: auto;
      height: 0;
      overflow: hidden;
      transition: all 1s ease-in-out;
    }
    .line2 {
      position: absolute;
      z-index: 5;
      width: 4px;
      height: 190px;
      top: 5900px;
      left: 0;
      right: 0;
      margin: auto;
      background: url(../assets/lanch_line.png) no-repeat 100%/100%;
    }
    .line3 {
      position: absolute;
      z-index: 5;
      width: 4px;
      height: 244px;
      top: 6380px;
      left: 0;
      right: 0;
      margin: auto;
      background: url(../assets/lanch_line.png) no-repeat 100%/100%;
    }
    .line_point {
      position: absolute;
      z-index: 11;
      top: 1840px;
      left: 0;
      right: 0;
      margin: auto;
      width: 14px;
      height: 14px;
      background: url(../assets/lanch_icon2.png) no-repeat 100%/100%;
      &.active {
        width: 28px;
        height: 28px;
        transition: all .5s ease-in-out;
        background: url(../assets/lanch_icon1.png) no-repeat 100%/100%;
      }
      &.small {
        width: 20px;
        height: 20px;
        transition: all .5s ease-in-out;
        background: url(../assets/lanch_icon1.png) no-repeat 100%/100%;
      }
    }
    .meteor {
      position: absolute;
      width: 130px;
      height: 130px;
      animation: meteorAnim 6s linear infinite;
      background: url(../assets/lanch_start1.png) no-repeat 100%/100%;
    }
    .meteor1 {
      position: absolute;
      width: 134px;
      height: 133px;
      animation: meteorAnim1 8s linear infinite;
      background: url(../assets/lanch_start2.png) no-repeat 100%/100%;
    }
    .meteor2 {
      position: absolute;
      width: 116px;
      height: 116px;
      animation: meteorAnim2 4s linear infinite;
      background: url(../assets/lanch_start3.png) no-repeat 100%/100%;
    }
    @keyframes meteorAnim {
      0% {
        top: -130px;
        left: 900px;
      }
      100% {
        top: 900px;
        left: -130px;
      }
    }
    @keyframes meteorAnim1 {
      0% {
        top: -134px;
        left: 600px;
      }
      100% {
        top: 600px;
        left: -134px;
      }
    }
    @keyframes meteorAnim2 {
      0% {
        top: -116px;
        left: 750px;
      }
      100% {
        top: 750px;
        left: -116px;
      }
    }
    @keyframes spin {
      from {
        transform: rotate(360deg);
      }
      to {
        transform: rotate(0);
      }
    }
    @keyframes shake2 {
      0%, 100% {
        // transform: translateX(0);
        transform:rotate(0)
      }
      10%, 30%, 50%, 70%, 90% {
        // transform: translateX(-20px);
        transform:rotate(9deg)
      }
      20%, 40%, 60%, 80% {
        // transform: translateX(20px);
        transform:rotate(-9deg)
      }
    }

    
    @keyframes run{
      0%{
        left:50%;
        top:0
      }
      12.5%{
        left:0;
        top:0;
        transform:translate(-50%, -50%) rotate(0deg);
      }
      12.51%{
        transform:translate(-50%, -50%) rotate(270deg);
      }
      25%{
        top:50%;
        left: 0;
      }
      37.5%{
        top:100%;
        left: 0;
        transform:translate(-50%, -50%) rotate(270deg);
      }
      37.51%{
        transform:translate(-50%, -50%) rotate(180deg);
      }

      50%{
        top:100%;
        left: 50%;
      }
      62.5%{
        top: 100%;
        left: 100%;
        transform:translate(-50%, -50%) rotate(180deg);
      }
      62.51%{
        transform:translate(-50%, -50%) rotate(90deg);
      }
      75%{
        top: 50%;
        left:100%;
      }
      87.5%{
        top:0;
        left: 100%;
        transform:translate(-50%, -50%) rotate(90deg);
      }
      87.51%{
        transform:translate(-50%, -50%) rotate(0deg);
      }
      100%{
        left:50%;
        top:0
      }
    }
    @keyframes run2{
      0%{
        left:50%;
        top:0
      }
      12.5%{
        left:100%;
        top:0;
        transform:translate(-50%, -50%) rotate(0deg);
      }
      12.51%{
        transform:translate(-50%, -50%) rotate(90deg);
      }
      25%{
        top:50%;
        left: 100%;
      }
      37.5%{
        top:100%;
        left: 100%;
        transform:translate(-50%, -50%) rotate(90deg);
      }
      37.51%{
        transform:translate(-50%, -50%) rotate(180deg);
      }
      50%{
        top:100%;
        left: 50%;
      }
      62.5%{
        top: 100%;
        left: 0%;
        transform:translate(-50%, -50%) rotate(180deg);
      }
      62.51%{
        transform:translate(-50%, -50%) rotate(270deg);
      }
      75%{
        top: 50%;
        left:0%;
      }
      87.5%{
        top:0;
        left: 0%;
        transform:translate(-50%, -50%) rotate(270deg);
      }
      87.51%{
        transform:translate(-50%, -50%) rotate(0deg);
      }
      100%{
        left:50%;
        top:0
      }
    }
    .cont {
      z-index: 10;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      width: 1200px;
      box-sizing: border-box;
    }
    .cont1 {
      top: 0;
      .title {
        text-align: left;
        font-size: 36px;
        color: #363F5E;
        font-weight: 600;
        line-height: 45px;
        margin: 126px 0 50px;
      }
      .desc {
        max-width: 700px;
        font-size: 26px;
        line-height: normal;
        margin-bottom: 50px;
        color: rgba(54, 63, 94, 0.68);
      }
      .btnList {
        display: flex;
        align-items: center;
        .btn {
          cursor: pointer;
          line-height: 1;
          font-size: 18px;
          font-weight: 600;
          color: #2AB26A;
          margin-right: 20px;
          padding: 12px 26px;
          border-radius: 58px;
          font-family: PingFang SC;
          background: rgba(255, 255, 255, 0.80);
        }
      }
      .tips {
        margin-top: 20px;
        font-size: 18px;
        line-height: 1;
        color: rgba(54, 63, 94, 0.68);
      }
      .gif {
        position: absolute;
        top: 60px;
        right: 0;
        width: 435px;
        height: 400px;
        img {
          width: 435px;
          height: 400px;
        }
      }
    }
    .cont2 {
      top: 520px;
      .videoPaly {
        width: 818px;
        height: 460px;
        margin: auto;
        video {
          width: 818px;
          height: 460px;
        }
      }
      .imgbg {
        position: relative;
        width: 1200px;
        height: 440px;
        background: url(../assets/cont2bg.png) no-repeat 100%/100%;
        .video1 {
          position: absolute;
          top: 115px;
          left: 10px;
          width: 490px;
          height: 300px;
          overflow: hidden;
          border-radius: 20px 50px;
          border: 10px solid #fff;
          video {
            width: 490px;
            height: 300px;
          }
        }
        .video2 {
          position: absolute;
          top: 115px;
          right: 10px;
          width: 490px;
          height: 300px;
          overflow: hidden;
          border-radius: 50px 20px;
          border: 10px solid #fff;
          video {
            width: 490px;
            height: 300px;
          }
        }
        .text {
          position: absolute;
          top: 342px;
          left: 0;
          right: 0;
          margin: auto;
          color: #FFF;
          font-size: 14px;
          font-weight: 600;
          text-align: center;
          line-height: normal;
          font-family: PingFang SC;
        }
      }
      .videoBtn {
        position: absolute;
        top: 460px;
        left: 0;
        right: 0;
        cursor: pointer;
        line-height: 1;
        color: #FFF;
        display: table;
        margin: auto;
        font-size: 24px;
        padding: 16px 50px;
        border-radius: 58px;
        font-family: PingFang SC;
        background: linear-gradient(99deg, #2AB26A 0%, rgba(104, 204, 79, 0.80) 100%);
      }
    }
    .cont3 {
      top: 1510px;
      width: 100%;
      .warp-data {
        width: 100%;
        overflow: hidden;
        .data_ul {
          width: max-content;
          display: flex;
          .data_li {
            margin-right: 50px;
            display: inline-flex;
            align-items: center;
            border-radius: 89.5px;
            padding: 8px 30px 8px 8px;
            backdrop-filter: blur(6px);
            background: linear-gradient(90deg, rgba(59, 221, 150, 0.40) 0%, rgba(59, 221, 150, 0.06) 100%);
            &.blank {
              width: 400px;
              background: transparent;
              backdrop-filter: none;
            }
            .left {
              width: 98px;
              height: 40px;
              font-size: 24px;
              font-weight: 600;
              color: #363F5E;
              line-height: 40px;
              font-style: normal;
              text-align: center;
              margin-right: 15px;
              border-radius: 89.5px;
              backdrop-filter: blur(6px);
              background: rgba(55, 197, 135, 0.60);
            }
            span {
              display: inline-block;
              font-size: 18px;
              font-weight: 600;
              color: rgba(54, 63, 94, 0.68);
            }
          }
        }
      }
      .text_desc {
        width: 100%;
        height: 140px;
        display: flex;
        margin-top: 30px;
        text-align: center;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        backdrop-filter: blur(4px);
        background: linear-gradient(90deg, rgba(158, 227, 154, 0.41) 3.39%, rgba(42, 178, 106, 0.68) 49.35%, rgba(158, 227, 154, 0.41) 97.54%);
        .title {
          font-size: 32px;
          font-weight: 600;
          color: #363F5E;
          line-height: 50px;
          margin-bottom: 12px;
        }
        .text {
          line-height: 1;
          font-size: 16px;
          color: rgba(54, 63, 94, 0.60);
        }
      }
    }
    .cont4 {
      top: 2300px;
      .title {
        font-size: 32px;
        font-weight: 600;
        color: #363F5E;
        text-align: center;
        line-height: normal;
        margin-bottom: 12px;
      }
      .desc {
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        line-height: normal;
        margin-bottom: 40px;
        color: rgba(54, 63, 94, 0.60);
      }
      .inlet {
        width: 100%;
        display: flex;
        margin-bottom: 50px;
        align-items: center;
        justify-content: space-between;
        &.show {
          display: flex; 
        }
        &.hide {
          display: none;
        }
        .round {
          display: flex;
          width: 168px;
          height: 168px;
          text-align: center;
          margin-top: 130px;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          background: url(../assets/lanch_round.png) no-repeat 100%/100%;
          .top {
            width: 100%;
            font-size: 36px;
            color: #358C66;
            font-weight: 600;
            margin-bottom: 5px;
            line-height: normal;
          }
          .text {
            width: 80%;
            font-size: 20px;
            line-height: normal;
            color: rgba(54, 63, 94, 0.60);
            &.text1 {
              font-size: 12px;
            }
          }
        }
        .center {
          position: relative;
          width: 405px;
          height: 360px;
          color: #FFF;
          font-size: 24px;
          line-height: 30px;
          text-align: center;
          background: url(../assets/lanch_cont4.png) no-repeat 100%/100%;
          .block1 {
            width: 100px;
            top: 40px;
            left: 0;
            right: 0;
            margin: auto;
            position: absolute;
          }
          .block2 {
            position: absolute;
            width: 100px;
            top: 250px;
            left: 32px;
          }
          .block3 {
            position: absolute;
            width: 100px;
            top: 250px;
            right: 32px;
          }
        }
      }
      
      .viewpoint {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .li {
          cursor: pointer;
          color: #2AB26A;
          font-size: 16px;
          font-weight: 400;
          padding: 12px 30px;
          line-height: normal;
          border-radius: 58px;
          display: inline-block;
          font-family: PingFang SC;
          background: rgba(255, 255, 255, 0.50);
        }
      }
    }
    .cont5 {
      // top: 2640px;
      top: 3500px;
      .title {
        font-size: 32px;
        font-weight: 600;
        color: #363F5E;
        text-align: center;
        line-height: normal;
        margin-bottom: 12px;
      }
      .intro {
        position: relative;
        margin: auto;
        width: 1200px;
        height: 480px;
        overflow: hidden;
        background: url(../assets/lanch_cont5bg.png) no-repeat 100%/100%;
        .topcenter {
          width: 300px;
          display: flex;
          font-size: 16px;
          font-weight: 400;
          margin: 100px auto;
          line-height: 22px; 
          font-family: PingFang SC;
          color: rgba(54, 63, 94, 0.80);
          justify-content: space-between;
        }
        .left, .right {
          position: absolute;
          top: 115px;
          left: 120px;
          width: 240px;
          .text1 {
            color: #363F5E;
            font-size: 28px;
            font-weight: 600;
            text-align: center;
            line-height: normal;
            margin-bottom: 12px;
          }
          .text2 {
            color: rgba(54, 63, 94, 0.60);
            text-align: center;
            font-size: 20px;
            line-height: normal;
          }
        }
        .right {
          position: absolute;
          left: unset;
          top: 115px;
          right: 120px;
        }
        .details {
          position: absolute;
          top: 380px;
          left: 0;
          right: 0;
          margin: auto;
          width: 300px;
          font-size: 16px;
          font-weight: 400;
          line-height: 26px;
          text-align: center;
          font-family: PingFang SC;
          color: rgba(54, 63, 94, 0.50);
        }
      }
    }
    .cont6 {
      top: 4120px;
      z-index: 4;
      .title {
        font-size: 32px;
        font-weight: 600;
        color: #363F5E;
        text-align: center;
        line-height: normal;
        margin-bottom: 12px;
      }
      .intro {
        width: 1200px;
        height: 420px;
        margin-top: 50px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        border-radius: 24px;
        box-sizing: border-box;
        border: 1px solid #fff;
        backdrop-filter: blur(6px);
        justify-content: space-around;
        background: rgba(255, 255, 255, 0.20);
        &.show {
          display: flex; 
        }
        &.hide {
          display: none;
        }
        .intro_li {
          width: 420px;
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          &.left {
            background: url(../assets/lanch_cont6li2.png) no-repeat 100%/100%;
          }
          &.right {
            background: url(../assets/lanch_cont6li1.png) no-repeat 100%/100%;
          }
          .left_1 {
            width: 310px;
            display: flex;
            padding: 0 10px;
            align-items: center;
            box-sizing: border-box;
            .text {
              width: 100%;
              font-size: 14px;
              font-weight: 400;
              line-height: 24px;
              text-align: right;
              color: rgba(54, 63, 94, 0.68);
            }
          }
          .left_2 {
            width: 100px;
            display: flex;
            margin-right: 10px;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            .icon {
              width: 30px;
              height: 30px;
            }
            .text {
              font-size: 20px;
              line-height: normal;
              color: rgba(255, 255, 255, 0.80);
            }
          }
          .right_1 {
            width: 260px;
            display: flex;
            padding: 0 10px;
            align-items: center;
            box-sizing: border-box;
            .text {
              width: 100%;
              font-size: 14px;
              font-weight: 400;
              line-height: 24px;
              text-align: left;
              color: rgba(54, 63, 94, 0.68);
            }
          }
          .right_2 {
            width: 155px;
            display: flex;
            margin-left: 5px;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            .icon {
              width: 30px;
              height: 30px;
            }
            .text {
              font-size: 20px;
              line-height: normal;
              color: rgba(255, 255, 255, 0.80);
            }
          }
          .icon1 {
            background: url(../assets/lanch_cont6icon1.png) no-repeat 100%/100%;
          }
          .icon2 {
            background: url(../assets/lanch_cont6icon2.png) no-repeat 100%/100%;
          }
          .icon3 {
            background: url(../assets/lanch_cont6icon3.png) no-repeat 100%/100%;
          }
          .icon4 {
            background: url(../assets/lanch_cont6icon4.png) no-repeat 100%/100%;
          }
          .icon5 {
            background: url(../assets/lanch_cont6icon5.png) no-repeat 100%/100%;
          }
          .icon6 {
            background: url(../assets/lanch_cont6icon6.png) no-repeat 100%/100%;
          }
        }
      }
    }
    .cont7 {
      top: 4800px;
      .title {
        font-size: 32px;
        font-weight: 600;
        color: #363F5E;
        text-align: center;
        line-height: normal;
        margin-bottom: 12px;
      }
      .desc {
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        line-height: normal;
        margin-bottom: 40px;
        color: rgba(54, 63, 94, 0.60);
      }
      .intro {
        position: relative;
        margin: auto;
        width: 1200px;
        height: 260px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: url(../assets/lanch_cont7bg.png) no-repeat 100%/100%;
        .left, .right {
          width: 550px;
          .top_text {
            font-size: 22px;
            font-weight: 600;
            line-height: normal;
            margin-bottom: 24px;
            letter-spacing: 0.88px;
            color: rgba(54, 63, 94, 0.86);
          }
          .text {
            font-size: 16px;
            line-height: normal;
            margin-bottom: 15px;
            color: rgba(54, 63, 94, 0.60);
          }
        }
        .left {
          text-align: right;
          .top_text {
            margin-right: 50px;
          }
          .text:nth-child(2) {
            margin-right: 35px;
          }
          .text:nth-child(3) {
            margin-right: 17px;
          }
          .text:nth-child(4) {
            margin-right: 0px;
          }
        }
        .right {
          width: 570px;
          .text:nth-child(2) {
            margin-left: 30px;
          }
          .text:nth-child(3) {
            margin-left: 50px;
          }
          .text:nth-child(4) {
            margin-left: 70px;
          }
        }
        .icon {
          position: absolute;
        }
        .icon1 {
          top: -80px;
          right: -30px;
          width: 160px;
          height: 176px;
          animation: spin 10s linear infinite;
          background: url(../assets/lanch_cont7icon1.png) no-repeat 100%/100%;
        }
        .icon2 {
          top: 130px;
          left: -50px;
          width: 180px;
          height: 180px;
          animation: spin 10s linear infinite;
          background: url(../assets/lanch_cont7icon2.png) no-repeat 100%/100%;
        }
      }
    }
    .cont8 {
      top: 5275px;
      .title {
        font-size: 32px;
        font-weight: 600;
        color: #363F5E;
        text-align: center;
        line-height: normal;
        margin-bottom: 43px;
      }
      .icon {
        position: absolute;
        top: -75px;
        right: 50px;
        width: 380px;
        height: 380px;
        z-index: 2;
        transform: translate(-50%, -50%);
        animation: shake 10s ease-in-out infinite;
        background: url(../assets/lanch_cont8icon.png) no-repeat 100%/100%;
      }
      @keyframes shake {
        0%, 100% {
          transform: translateX(0);
        }
        10%, 30%, 50%, 70%, 90% {
          transform: translateX(-20px);
        }
        20%, 40%, 60%, 80% {
          transform: translateX(20px);
        }
      }
      .intro {
        position: relative;
        margin: auto;
        width: 1200px;
        height: 540px;
        border-radius: 22px;
        overflow: hidden;
        background: url(../assets/lanch_cont8bg.png) no-repeat 100%/100%;
        background-size: 1200px 540px;
        .line_text {
          font-size: 12px;
          line-height: normal;
          color: rgba(54, 63, 94, 0.60);
        }
        .ele1 {
          position: absolute;
          top: 118px;
          left: 160px;
        }
        .ele2 {
          position: absolute;
          top: 155px;
          left: 550px;
        }
        .ele3 {
          position: absolute;
          top: 275px;
          right: 430px;
        }
        .ele4 {
          position: absolute;
          top: 360px;
          left: 440px;
        }
        .ele5 {
          position: absolute;
          top: 435px;
          right: 365px;
        }
        .ele6 {
          position: absolute;
          bottom: 85px;
          left: 335px;
        }
        .ele7 {
          position: absolute;
          top: 55px;
          left: 529px;
          width: 88px;
          height: 88px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          .icon1 {
            width: 24px;
            height: 24px;
            margin-bottom: 8px;
            background: url(../assets/lanch_cont8icon1.png) no-repeat 100%/100%;
          }
          .text {
            font-size: 16px;
            line-height: normal;
            color: rgba(54, 63, 94, 0.80);
          }
        }
        .ele8 {
          position: absolute;
          width: 388px;
          height: 140px;
          top: 204px;
          left: 270px;
          padding: 15px 20px;
          box-sizing: border-box;
          .text {
            font-size: 20px;
            font-weight: 600;
            color: #363F5E;
            text-align: center;
            line-height: normal;
            margin-bottom: 2px;
          }
          .text1 {
            font-size: 15px;
            text-align: center;
            line-height: normal;
            margin-bottom: 10px;
            color: rgba(54, 63, 94, 0.66);
          }
          .list {
            display: flex;
            flex-wrap: wrap;
            font-size: 14px;
            font-weight: 400;
            line-height: normal;
            align-items: center;
            justify-content: space-between;
            color: rgba(54, 63, 94, 0.50);
            p {
              width: 50%;
              margin-bottom: 4px;
            }
          }
        }
        .ele9 {
          position: absolute;
          width: 320px;
          height: 115px;
          top: 226px;
          right: 50px;
          display: flex;
          padding: 15px 20px;
          align-items: center;
          flex-direction: column;
          box-sizing: border-box;
          justify-content: center;
          .text {
            font-size: 20px;
            font-weight: 600;
            color: #363F5E;
            line-height: normal;
            margin-bottom: 2px;
          }
          .text1 {
            font-size: 15px;
            line-height: normal;
            margin-bottom: 10px;
            color: rgba(54, 63, 94, 0.66);
          }
          .buy {
            font-size: 14px;
            font-weight: 400;
            line-height: normal;
            color: rgba(54, 63, 94, 0.60);
          }
        }
        .ele10 {
          position: absolute;
          width: 180px;
          height: 95px;
          top: 398px;
          left: 45px;
          display: flex;
          padding: 15px 20px;
          align-items: center;
          flex-direction: column;
          box-sizing: border-box;
          justify-content: center;
          .text {
            font-size: 20px;
            font-weight: 600;
            color: #363F5E;
            line-height: normal;
            margin-bottom: 2px;
          }
          .text1 {
            font-size: 15px;
            line-height: normal;
            color: rgba(54, 63, 94, 0.66);
          }
        }
        .ele11 {
          position: absolute;
          top: 402px;
          left: 420px;
          width: 88px;
          height: 88px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          .icon1 {
            width: 24px;
            height: 24px;
            margin-bottom: 8px;
            background: url(../assets/lanch_cont8icon1.png) no-repeat 100%/100%;
          }
          .text {
            font-size: 16px;
            line-height: normal;
            color: rgba(54, 63, 94, 0.80);
          }
        }
        .ele12 {
          position: absolute;
          width: 250px;
          height: 95px;
          top: 398px;
          right: 45px;
          display: flex;
          padding: 15px 20px;
          align-items: center;
          flex-direction: column;
          box-sizing: border-box;
          justify-content: center;
          .text {
            font-size: 20px;
            font-weight: 600;
            color: #363F5E;
            line-height: normal;
            margin-bottom: 2px;
          }
          .text1 {
            font-size: 15px;
            line-height: normal;
            color: rgba(54, 63, 94, 0.66);
          }
        }
      }
      .intro::after, .intro::before{
        content: '';
        width: 160px;
        height: 4px;
        position: absolute;
        top: 2px;
        left: 150px
      }
      .intro::before{
        left: 50px;
        animation: run 4s linear infinite;
        background: url(../assets/lanch_border2.png) no-repeat 100%/100%;
        transform: translate(-50%, -50%);
      }
      .intro::after{
        animation: run2 4s linear infinite;
        background: url(../assets/lanch_border1.png) no-repeat 100%/100%;
        transform: translate(-50%, -50%);
      }
    }
    .cont9 {
      top: 5990px;
      .title {
        font-size: 32px;
        font-weight: 600;
        color: #363F5E;
        text-align: center;
        line-height: normal;
        margin-bottom: 30px;
      }
      .intro {
        width: 1200px;
        height: 350px;
        display: flex;
        overflow: hidden;
        align-items: center;
        border-radius: 24px;
        box-sizing: border-box;
        border: 1px solid #fff;
        backdrop-filter: blur(6px);
        justify-content: space-around;
        background: rgba(255, 255, 255, 0.20);
        &::after, &::before{
          content: '';
          width: 160px;
          height: 4px;
          position: absolute;
          top: 2px;
          left: 150px
        }
        &::before{
          left: 50px;
          animation: run 4s linear infinite;
          background: url(../assets/lanch_border2.png) no-repeat 100%/100%;
          transform: translate(-50%, -50%);
        }
        &::after{
          animation: run2 4s linear infinite;
          background: url(../assets/lanch_border1.png) no-repeat 100%/100%;
          transform: translate(-50%, -50%);
        }
        .left {
          width: 268px;
          height: 268px;
          transform: translate(-50%, -50%);
          animation: shake1 20s ease-in-out infinite;
          background: url(../assets/lanch_cont9img.png) no-repeat 100%/100%;
        }
        @keyframes shake1 {
          0%, 100% {
            transform: translateX(0);
            transform: translatey(0);
          }
          10%, 30%, 50%, 70%, 90% {
            transform: translateX(-20px);
            transform: translatey(-20px);
          }
          20%, 40%, 60%, 80% {
            transform: translatey(20px);
            transform: translateX(20px);
          }
        }
        .right {
          width: 840px;
          .topcont {
            width: 690px;
            height: 94px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            .user {
              width: 88px;
              height: 88px;
              display: flex;
              border-radius: 20px;
              align-items: center;
              flex-direction: column;
              justify-content: center;
              backdrop-filter: blur(6px);
              background: rgba(255, 255, 255, 0.40);
              .icon1 {
                width: 24px;
                height: 24px;
                margin-bottom: 8px;
                background: url(../assets/lanch_cont8icon1.png) no-repeat 100%/100%;
              }
              .text {
                font-size: 16px;
                line-height: normal;
                color: rgba(54, 63, 94, 0.80);
              }
            }
            .text_line {
              display: flex;
              font-size: 12px;
              line-height: normal;
              align-items: center;
              color: rgba(54, 63, 94, 0.50);
              .arrow {
                width: 76px;
                height: 27px;
                margin-left: 5px;
                display: inline-block;
                background: url(../assets/lanch_cont9arrow.png) no-repeat 100%/100%;
              }
            }
            .block {
              width: 250px;
              height: 94px;
              display: flex;
              padding: 15px 20px;
              align-items: center;
              border-radius: 24px;
              flex-direction: column;
              box-sizing: border-box;
              justify-content: center;
              background: rgba(255, 255, 255, 0.40);
              .text {
                font-size: 20px;
                font-weight: 600;
                color: #363F5E;
                line-height: normal;
                margin-bottom: 2px;
              }
              .text1 {
                font-size: 15px;
                line-height: normal;
                color: rgba(54, 63, 94, 0.66);
              }
            }
          }
          .list {
            width: 840px;
            height: 160px;
            display: flex;
            padding: 10px 0;
            flex-wrap: wrap;
            margin-top: 30px;
            border-radius: 20px;
            align-items: center;
            box-sizing: border-box;
            justify-content: space-around;
            background: rgba(255, 255, 255, 0.30);
            .li{
              width: 45%;
              height: 60px;
              text-align: center;
              line-height: normal;
              .num {
                font-size: 18px;
                font-weight: 600;
                color: rgba(54, 63, 94, 0.16);
              }
              .text{
                font-size: 14px;
                font-weight: 400;
                color: rgba(54, 63, 94, 0.56);
              }
            }
          }
        }
      }
    }
    .cont10 {
      top: 6530px;
      .title {
        font-size: 32px;
        font-weight: 600;
        color: #363F5E;
        text-align: center;
        line-height: normal;
        margin-bottom: 30px;
      }
      .intro {
        width: 100%;
        display: flex;
        margin-top: 50px;
        justify-content: space-between;
        &.show {
          display: flex;
        }
        &.hide {
          display: none;
        }
        .left_li, .right_li {
          width: 540px;
          line-height: normal;
          .li {
            margin-bottom: 35px;
            .li_title {
              font-size: 18px;
              font-weight: 600;
              color: #363F5E;
            }
            .li_text {
              font-size: 14px;
              line-height: normal;
              color: rgba(54, 63, 94, 0.66);
            }
          }
        }
        .left_li {
          text-align: right;
        }
        .right_li {
          padding-top: 65px;
          text-align: left;
        }
      }
    }
    .cont11 {
      top: 7440px;
      .title {
        font-size: 32px;
        font-weight: 600;
        color: #363F5E;
        text-align: center;
        line-height: normal;
        margin-bottom: 40px;
      }
      .intro {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .userimg {
          z-index: 2;
          width: 300px;
          height: 300px;
          background: url(../assets/lanch_cont11img.png) no-repeat 100%/100%;
        }
        .scan {
          position: absolute;
          top: 0;
          left: 160px;
          width: 0;
          height: 335px;
          &.active {
            width: 234px;
            transition:width 1s;
            background: url(../assets/lanch_cont11img1.png) no-repeat 100%/100%;
          }
        }
        .scan1 {
          display: none;
        }
        .datalist {
          width: 840px;
          display: flex;
          flex-wrap: wrap;
          .datali {
            width: 50%;
            height: 80px;
            display: flex;
            .point {
              width: 20px;
              height: 20px;
              margin: 2px 10px 0 0;
              background: url(../assets/lanch_icon1.png) no-repeat 100%/100%;
            }
            .data {
              flex: 1;
              padding-right: 10px;
              box-sizing: border-box;
              .top {
                color: #363F5E;
                font-size: 18px;
                font-weight: 600;
                margin-bottom: 4px;
                line-height: normal;
              }
              .text {
                font-size: 14px;
                line-height: normal;
                color: rgba(54, 63, 94, 0.66);
              }
            }
          }
        }
      }
    }
    .cont12 {
      top: 7980px;
      .intro {
        width: 1200px;
        height: 600px;
        display: flex;
        align-items: center;
        border-radius: 20px;
        justify-content: space-around;
        background: linear-gradient(180deg, rgba(152, 217, 182, 0.18) 6.92%, rgba(200, 227, 213, 0.16) 100%);
        .echarDom {
          width: 600px;
          height: 600px;
        }
        .details {
          width: 480px;
          height: 420px;
          overflow: hidden;
          padding: 24px 20px;
          line-height: normal;
          border-radius: 24px;
          box-sizing: border-box;
          backdrop-filter: blur(6px);
          background: rgba(255, 255, 255, 0.30);
          &.Total {
            text-align: center;
            padding: 24px 80px;
            .title {
              font-size: 20px;
              font-weight: 600;
              color: #363F5E;
              margin-bottom: 16px;
            }
            .block {
              text-align: center;
              font-size: 14px;
              margin-bottom: 24px;
              .text {
                color: rgba(54, 63, 94, 0.50);
              }
              .desc {
                color: #363F5E;
              }
            }
            
          }
          &.Single {
            .title {
              font-size: 20px;
              font-weight: 600;
              color: #363F5E;
              text-align: center;
              margin-bottom: 16px;
            }
            .dataList {
              .data_top {
                display: flex;
                font-size: 16px;
                color: #363F5E;
                align-items: center;
                span {
                  width: 8px;
                  height: 8px;
                  margin-right: 8px;
                  border-radius: 100%;
                  display: inline-block;
                  background: #363F5E;
                }
              }
              .text {
                font-size: 14px;
                color: rgba(54, 63, 94, 0.66);
                span {
                  font-weight: 400;
                  color: rgba(54, 63, 94, 0.40);
                }
              }
            }
          }
          &.font12 {
            padding: 12px 10px;
            .title {
              font-size: 16px;
              font-weight: 600;
              color: #363F5E;
              text-align: center;
              margin-bottom: 8px;
            }
            .dataList {
              margin-bottom: 5px;
              .data_top {
                display: flex;
                font-size: 14px;
                color: #363F5E;
                align-items: center;
                span {
                  width: 8px;
                  height: 8px;
                  margin-right: 8px;
                  border-radius: 100%;
                  display: inline-block;
                  background: #363F5E;
                }
              }
              .text {
                font-size: 12px;
                color: rgba(54, 63, 94, 0.66);
                span {
                  font-weight: 400;
                  color: rgba(54, 63, 94, 0.40);
                }
              }
            }
          }
        }
      }
    }
    .cont13 {
      top: 8650px;
      width: 1100px;
      .title {
        font-size: 32px;
        font-weight: 600;
        color: #363F5E;
        text-align: center;
        line-height: normal;
        margin-bottom: 40px;
      }
      .teamlist {
        display: flex;
        flex-wrap: wrap;
        .teamli {
          position: relative;
          width: 220px;
          height: 295px;
          overflow: hidden;
          border-radius: 24px;
          margin: 0 72px 24px 0;
          transition: all .3s ease-in-out;
          background: rgba(255, 255, 255, 0.60);
          &:hover {
            box-shadow: 0 0 4px 4px rgba(42, 178, 106, 0.50);
            -webkit-transform: translateY(-10px);
            -ms-transform: translateY(-10px);
            transform: translateY(-10px);
            .name {
              background: rgba(42, 178, 106, 0.50);
            }
          }
          &:nth-child(4n){
            margin-right: 0;
          }
          .userimg {
            width: 220px;
            height: 295px;
            img {
              width: 220px;
              min-height: 295px;
            }
          }
          .name {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 50px;
            display: flex;
            color: #FFF;
            font-size: 16px;
            text-align: center;
            line-height: normal;
            align-items: center;
            justify-content: center;
            background: rgba(255, 255, 255, 0.6);
            text-shadow: 0px 2px 16px rgba(54, 63, 94, 0.6)
          }
        }
      }
      .detailsInfo {
        position: absolute;
        top: 385px;
        left: 0;
        width: 1100px;
        padding: 30px;
        text-align: center;
        background: #FFF;
        border-radius: 24px;
        line-height: normal;
        box-sizing: border-box;
        &.show {
          display: block;
        }
        &.hide {
          display: none;
        }
        &.top1 {
          top: 710px;
          left: 0;
          right: 0;
          margin: auto;
          z-index: 12;
        }
        .name {
          font-size: 20px;
          font-weight: 600;
          color: #363F5E;
          margin-bottom: 5px;
        }
        .synopsis {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 15px;
          color: rgba(78, 89, 105, 0.80);
        }
        .text {
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          text-align: center;
          color: rgba(78, 89, 105, 0.80);
        }
      }
    }
    .cont14 {
      // top: 7930px;
      z-index: 5;
      top: 9430px;
      .title {
        font-size: 32px;
        font-weight: 600;
        color: #363F5E;
        text-align: center;
        line-height: normal;
        margin-bottom: 30px;
      }
      .organList {
        width: 100%;
        display: flex;
        justify-content: space-around;
        img {
          width: 240px;
          height: 100px;
          transition: all .3s ease-in-out;
          &:hover {
            -webkit-transform: translateY(-10px);
            -ms-transform: translateY(-10px);
            transform: translateY(-10px);
          }
        }
      }
      .organInfo {
        position: absolute;
        top: 170px;
        left: 0;
        width: 1200px;
        padding: 30px;
        font-size: 14px;
        background: #FFF;
        border-radius: 24px;
        line-height: normal;
        box-sizing: border-box;
        color: rgba(78, 89, 105, 0.80);
      }
    }
    .cont15 {
      // top: 8200px;
      top: 9650px;
      z-index: 1;
      .title {
        font-size: 32px;
        font-weight: 600;
        color: #363F5E;
        text-align: center;
        line-height: normal;
        margin-bottom: 30px;
      }
      .communityList {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        &.show {
          display: flex;
        }
        &.hide {
          display: none;
        }
        .community {
          width: 380px;
          cursor: pointer;
          margin: 0 20px 50px 0;
          transition: all .3s ease-in-out;
          &:hover {
            -webkit-transform: translateY(-10px);
            -ms-transform: translateY(-10px);
            transform: translateY(-10px);
          }
          &:nth-child(3n) {
            margin-right: 0;
          }
          .act_img {
            width: 380px;
            height: 220px;
            display: flex;
            line-height: 0;
            overflow: hidden;
            align-items: center;
            img {
              width: 380px;
              min-height: 220px;
            }
          }
          .act_name {
            width: 100%;
            font-size: 18px;
            font-weight: 500;
            overflow: hidden;
            margin: 10px 0 5px;
            white-space: nowrap;
            line-height: normal;
            box-sizing: border-box;
            text-overflow: ellipsis;
            color: rgba(54, 63, 94, 0.88);
          }
          .act_time {
            font-size: 14px;
            font-weight: 400;
            line-height: normal;
            box-sizing: border-box;
            color: rgba(54, 63, 94, 0.60);
          }
        }
      }
    }
    .cont16 {
      top: 1800px;
      .title {
        font-size: 32px;
        font-weight: 600;
        color: #363F5E;
        text-align: center;
        line-height: normal;
        margin-bottom: 12px;
      }
      .desc {
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        line-height: normal;
        margin-bottom: 40px;
        color: rgba(54, 63, 94, 0.60);
      }
      .product {
        width: 1100px;
        display: flex;
        margin: auto;
        align-items: center;
        justify-content: space-between;
        .pro_cont { 
          width: 240px;
          height: 300px;
          display: flex;
          align-items: center;
          padding: 24px 20px;
          border-radius: 20px;
          flex-direction: column;
          box-sizing: border-box;
          border: 2px solid #FFF;
          backdrop-filter: blur(6px);
          background: rgba(255, 255, 255, 0.60);
          .title {
            width: 100%;
            height: 50px;
            display: flex;
            line-height: 1;
            font-size: 20px;
            font-weight: 600;
            text-align: center;
            font-family: MiSans;
            align-items: center;
            margin-bottom: 15px;
            justify-content: center; 
            color: rgba(54, 63, 94, 0.80);
          }
          .span {
            color: #22A560;
            font-family: PingFang SC;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            gap: 12px;
            display: flex;
            margin-bottom: 8px;
            padding: 8px 30px;
            align-items: center;
            border-radius: 58px;
            background: #E0E6F3;
            justify-content: center;
          }
          .img {
            gap: 12px;
            display: flex;
            width: 160px;
            padding: 4px 24px;
            background: #FFF;
            border-radius: 58px;
            align-items: center;
            margin-bottom: 8px;
            justify-content: center;
            img {
              max-width: 148px;
              max-height: 40px;
            }
          }
        }
      }
    }
    .cont17 {
      top: 2980px;
      .title {
        font-size: 32px;
        font-weight: 600;
        color: #363F5E;
        text-align: center;
        line-height: normal;
        margin-bottom: 40px;
      }
      .mode {
        width: 750px;
        margin: auto;
        height: 300px;
        position: relative;
        .modetype {
          position: absolute;
          width: 400px;
          height: 300px;
          flex-shrink: 0;
          line-height: normal;  
          text-align: center;
          font-family: MiSans;
          padding: 70px 70px 0;
          box-sizing: border-box;
          backdrop-filter: blur(3px);
          border-radius: 200px / 150px;
          .title {
            font-size: 28px;
            font-weight: 600;
            color: #363F5E;
            margin-bottom: 12px;
          }
          .desc {
            font-size: 20px;
            font-weight: 500;
            letter-spacing: 0.4px;
            color: rgba(54, 63, 94, 0.60);
          }
        }
        .mode1 {
          left: 0;
          background: linear-gradient(129deg, rgba(92, 200, 207, 0.50) 14.99%, rgba(131, 232, 189, 0.20) 86.16%);
        }
        .mode2 {
          right: 0;
          background: linear-gradient(235deg, rgba(92, 200, 207, 0.50) 13.78%, rgba(131, 232, 189, 0.20) 89.16%);
        }
      }
    }
  }
  .dialogVideo {
    width: 100%;
    
    video {
      width: 100%;
    }
  }
}
.lan_En.Lanchpad {
  .content  {
    &.content1 {
      width: 100%;
      height: 10720px;
      overflow: hidden;
      background: url("../assets/lanchpadbg.png") no-repeat center;
      background-size: 100% 10720px;
    }
    .cont3 {
      .text_desc {
        .title {
          font-size: 26px;
          line-height: 1.1;
        }
      }
    }
    .cont4 {
      .inlet {
        .center {
          font-size: 18px;
          .block1 {
            width: 120px;
          }
          .block3 {
            width: 120px;
          }
        }
        .round {
          .top {
            font-size: 28px;
          }
          .text {
            font-size: 16px;
            &.text1 {
              font-size: 12px;
            }
          }
        }
      }
    }
    .cont5 {
      .intro {
        .left {
          width: 280px;
          left: 101px;
          .text1 {
            font-size: 24px;
          }
        }
        .right {
          width: 280px;
          right: 99px;
        }
      }
    }
    .cont6 {
      // top: 4180px;
      .intro {
        .intro_li {
          text-align: center;
          .lineH1 {
            .text {
              line-height: 1;
            }
          }
        }
      }
    }
    .cont7 {
      top: 4745px;
      .intro {
        .left {
          .top_text {
            font-size: 20px;
          }
          .text {
            font-size: 14px;
          }
        }
        .right {
          .top_text {
            font-size: 20px;
          }
          .text {
            font-size: 14px;
            margin-bottom: 10px;
          }
        }
      }
    }
    .cont8 {
      // top: 5340px;
      .title {
        position: relative;
        z-index: 5;
      }
      .intro {
        .ele5 {
          top: 440px;
        }
        .ele6 {
          bottom: 80px;
        }
      }
    }
    .cont9 {
      // top: 6080px;
      .intro {
        .right {
          .topcont {
            .block {
              padding: 15px 5px;
              .text {
                font-size: 16px;
              }
              .text1 {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
    .cont11 {
      top: 7520px;
      .intro {
        .userimg {
          height: 335px;
        }
        .scan.active {
          height: 380px;
          background-size: 234px 380px;
        }
        .datalist {
          .datali {
            height: 75px;
            .data {
              .top {
                font-size: 16px;
              }
              .text {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
    .cont12 {
      top: 8020px;
      .intro {
        .details{
          height: 300px;
          &.font12 {
            height: 450px;
          }
        }
      }
    }
    .cont13 {
      top: 8675px;
    }
    .cont17 {
      .mode {
        .modetype {
          .title {
            font-size: 24px;
          }
          .desc {
            font-size: 16px;
          }
        }
      }
    }
  }
  
}

@media screen and (max-width: 1200px){
  .Lanchpad {
    min-width: 600px;
    .content {
      min-width: unset;
      &.content1 {
        width: 100%;
        min-width: 600px;
        height: 14050px;
        overflow: hidden;
        background: url("../assets/lanchpadbg.png") no-repeat center;
        background-size: 100% 14050px;
      }
      .bg1 {
        position: absolute;
        top: -250px;
        left: -150px;
        width: 750px;
        height: 750px;
        background: url(../assets/lanch_bg1.png) no-repeat 100%/100%;
      }
      .bg2 {
        position: absolute;
        z-index: 11;
        top: -100px;
        right: -100px;
        width: 400px;
        height: 400px;
        background: url(../assets/lanch_bg2.png) no-repeat 100%/100%;
      }
      .bg3 {
        position: absolute;
        z-index: 1;
        top: 872px;
        right: -300px;
        width: 720px;
        height: 720px;
        animation: spin 10s linear infinite;
        background: url(../assets/lanch_bg3.png) no-repeat 100%/100%;
      }
      .bg4 {
        z-index: 11;
        position: absolute;
        top: 9210px;
        right: 42px;
        width: 200px;
        height: 200px;
        background: url(../assets/lanch_bg4.png) no-repeat 100%/100%;
      }
      .bg5 {
        z-index: 11;
        position: absolute;
        top: 2700px;
        right: -125px;
        width: 270px;
        height: 270px;
        animation: shake2 10s linear infinite;
        background: url(../assets/lanch_iocn9.png) no-repeat 100%/100%;
      }
      .bg6 {
        z-index: 11;
        position: absolute;
        top: 3500px;
        left: -120px;
        width: 300px;
        height: 300px;
        animation: shake2 6s linear infinite;
        background: url(../assets/lanch_iocn7.png) no-repeat 100%/100%;
      }
      
      .bg7 {
        z-index: 1;
        position: absolute;
        top: 6800px;
        left: -100px;
        width: 280px;
        height: 280px;
        animation: shake2 8s linear infinite;
        background: url(../assets/lanch_iocn4.png) no-repeat 100%/100%;
      }
      
      .bg8 {
        z-index: 11;
        position: absolute;
        top: 4460px;
        right: -100px;
        width: 240px;
        height: 240px;
        animation: shake2 12s linear infinite;
        background: url(../assets/lanch_iocn5.png) no-repeat 100%/100%;
      }
      
      .bg9 {
        z-index: 11;
        position: absolute;
        top: 5270px;
        left: -120px;
        width: 300px;
        height: 300px;
        animation: shake2 20s linear infinite;
        background: url(../assets/lanch_iocn6.png) no-repeat 100%/100%;
      }
      .bg10 {
        z-index: 11;
        position: absolute;
        top: 11800px; 
        right: 0;
        width: 170px;
        height: 210px;
        background: url(../assets/lanch_iocn10.png) no-repeat 100%/100%;
      }
      .bg11 {
        z-index: 11;
        position: absolute;
        top: 10360px;
        left: -71px;
        width: 200px;
        height: 200px;
        animation: shake2 15s linear infinite;
        background: url(../assets/lanch_iocn8.png) no-repeat 100%/100%;
      }


      .line {
        display: none;
        position: absolute;
        z-index: 5;
        width: 228px;
        top: 1812px;
        left: 0;
        right: 0;
        margin: auto;
        height: 0;
        overflow: hidden;
        transition: all 1s ease-in-out;
      }
      .line2 {
        display: none;
        position: absolute;
        z-index: 5;
        width: 4px;
        height: 190px;
        top: 4960px;
        left: 0;
        right: 0;
        margin: auto;
        background: url(../assets/lanch_line.png) no-repeat 100%/100%;
      }
      .line3 {
        display: none;
        position: absolute;
        z-index: 5;
        width: 4px;
        height: 244px;
        top: 5490px;
        left: 0;
        right: 0;
        margin: auto;
        background: url(../assets/lanch_line.png) no-repeat 100%/100%;
      }
      .line_point {
        display: none;
        position: absolute;
        z-index: 11;
        top: 1800px;
        left: 0;
        right: 0;
        margin: auto;
        width: 14px;
        height: 14px;
        background: url(../assets/lanch_icon2.png) no-repeat 100%/100%;
        &.active {
          width: 28px;
          height: 28px;
          transition: all .5s ease-in-out;
          background: url(../assets/lanch_icon1.png) no-repeat 100%/100%;
        }
        &.small {
          width: 20px;
          height: 20px;
          transition: all .5s ease-in-out;
          background: url(../assets/lanch_icon1.png) no-repeat 100%/100%;
        }
      }
      .meteor {
        position: absolute;
        width: 130px;
        height: 130px;
        animation: meteorAnim 6s linear infinite;
        background: url(../assets/lanch_start1.png) no-repeat 100%/100%;
      }
      .meteor1 {
        position: absolute;
        width: 134px;
        height: 133px;
        animation: meteorAnim1 8s linear infinite;
        background: url(../assets/lanch_start2.png) no-repeat 100%/100%;
      }
      .meteor2 {
        position: absolute;
        width: 116px;
        height: 116px;
        animation: meteorAnim2 4s linear infinite;
        background: url(../assets/lanch_start3.png) no-repeat 100%/100%;
      }
      @keyframes meteorAnim {
        0% {
          top: -130px;
          left: 900px;
        }
        100% {
          top: 900px;
          left: -130px;
        }
      }
      @keyframes meteorAnim1 {
        0% {
          top: -134px;
          left: 600px;
        }
        100% {
          top: 600px;
          left: -134px;
        }
      }
      @keyframes meteorAnim2 {
        0% {
          top: -116px;
          left: 750px;
        }
        100% {
          top: 750px;
          left: -116px;
        }
      }
      @keyframes spin {
        from {
          transform: rotate(360deg);
        }
        to {
          transform: rotate(0);
        }
      }
      @keyframes shake2 {
        0%, 100% {
          // transform: translateX(0);
          transform:rotate(0)
        }
        10%, 30%, 50%, 70%, 90% {
          // transform: translateX(-20px);
          transform:rotate(9deg)
        }
        20%, 40%, 60%, 80% {
          // transform: translateX(20px);
          transform:rotate(-9deg)
        }
      }

      
      @keyframes run{
        0%{
          left:50%;
          top:0
        }
        12.5%{
          left:0;
          top:0;
          transform:translate(-50%, -50%) rotate(0deg);
        }
        12.51%{
          transform:translate(-50%, -50%) rotate(270deg);
        }
        25%{
          top:50%;
          left: 0;
        }
        37.5%{
          top:100%;
          left: 0;
          transform:translate(-50%, -50%) rotate(270deg);
        }
        37.51%{
          transform:translate(-50%, -50%) rotate(180deg);
        }

        50%{
          top:100%;
          left: 50%;
        }
        62.5%{
          top: 100%;
          left: 100%;
          transform:translate(-50%, -50%) rotate(180deg);
        }
        62.51%{
          transform:translate(-50%, -50%) rotate(90deg);
        }
        75%{
          top: 50%;
          left:100%;
        }
        87.5%{
          top:0;
          left: 100%;
          transform:translate(-50%, -50%) rotate(90deg);
        }
        87.51%{
          transform:translate(-50%, -50%) rotate(0deg);
        }
        100%{
          left:50%;
          top:0
        }
      }
      @keyframes run2{
        0%{
          left:50%;
          top:0
        }
        12.5%{
          left:100%;
          top:0;
          transform:translate(-50%, -50%) rotate(0deg);
        }
        12.51%{
          transform:translate(-50%, -50%) rotate(90deg);
        }
        25%{
          top:50%;
          left: 100%;
        }
        37.5%{
          top:100%;
          left: 100%;
          transform:translate(-50%, -50%) rotate(90deg);
        }
        37.51%{
          transform:translate(-50%, -50%) rotate(180deg);
        }
        50%{
          top:100%;
          left: 50%;
        }
        62.5%{
          top: 100%;
          left: 0%;
          transform:translate(-50%, -50%) rotate(180deg);
        }
        62.51%{
          transform:translate(-50%, -50%) rotate(270deg);
        }
        75%{
          top: 50%;
          left:0%;
        }
        87.5%{
          top:0;
          left: 0%;
          transform:translate(-50%, -50%) rotate(270deg);
        }
        87.51%{
          transform:translate(-50%, -50%) rotate(0deg);
        }
        100%{
          left:50%;
          top:0
        }
      }
      .cont {
        width: 100%;
        z-index: 10;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        min-width: 600px;
        box-sizing: border-box;
      }
      .cont1 {
        top: 0;
        .title {
          text-align: center;
        }
        .desc {
          text-align: center;
        }
        .btnList {
          display: flex;
          align-items: center;
          justify-content: center;
          .btn {
            &:last-child {
              margin-right: 0;
            }
          }
        }
        .tips {
          text-align: center;
        }
        .gif {
          display: none;
        }
      }
      .cont2 {
        top: 520px;
        .videoPaly {
          width: 600px;
          height: 360px;
          margin: auto;
          video {
            width: 600px;
            height: 300px;
          }
        }
        .imgbg {
          position: relative;
          width: 100%;
          height: 700px;
          background: url(../assets/lanch_cont2bg_phone.png) no-repeat;
          background-size: 315px 296px;
          background-position: 100% 188px;
          video {
            width: 490px;
            height: 300px;
          }
          .video1 {
            top: -25px;
            left: 50px;
          }
          .video2 {
            top: 415px;
            left: 50px;
            right: unset;
          }
          .text {
            left: 250px;
          }
        }
        .videoBtn {
          position: unset;
          top: 770px;
          margin: 75px auto 0;
        }
      }
      .cont3 {
        top: 1760px;
        width: 100%;
        .warp-data {
          width: 100%;
          overflow: hidden;
          .data_ul {
            width: max-content;
            display: flex;
            .data_li {
              margin-right: 50px;
              display: inline-flex;
              align-items: center;
              border-radius: 89.5px;
              padding: 8px 30px 8px 8px;
              backdrop-filter: blur(6px);
              background: linear-gradient(90deg, rgba(59, 221, 150, 0.40) 0%, rgba(59, 221, 150, 0.06) 100%);
              &.blank {
                width: 400px;
                background: transparent;
                backdrop-filter: none;
              }
              .left {
                width: 98px;
                height: 40px;
                font-size: 24px;
                font-weight: 600;
                color: #363F5E;
                line-height: 40px;
                font-style: normal;
                text-align: center;
                margin-right: 15px;
                border-radius: 89.5px;
                backdrop-filter: blur(6px);
                background: rgba(55, 197, 135, 0.60);
              }
              span {
                display: inline-block;
                font-size: 18px;
                font-weight: 600;
                color: rgba(54, 63, 94, 0.68);
              }
            }
          }
        }
        .text_desc {
          width: 100%;
          height: 140px;
          display: flex;
          margin-top: 30px;
          text-align: center;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          backdrop-filter: blur(4px);
          background: linear-gradient(90deg, rgba(158, 227, 154, 0.41) 3.39%, rgba(42, 178, 106, 0.68) 49.35%, rgba(158, 227, 154, 0.41) 97.54%);
          .title {
            font-size: 30px;
            font-weight: 600;
            color: #363F5E;
            line-height: 40px;
            margin-bottom: 12px;
          }
          .text {
            line-height: 1;
            font-size: 16px;
            color: rgba(54, 63, 94, 0.60);
          }
        }
      }
      .cont16 {
        top: 2040px;
        .title {
          font-size: 28px;
        }
        .product {
          width: 600px;
          flex-wrap: wrap;
          .pro_cont {
            width: 290px;
            margin-bottom: 20px;
          }
        }
      }
      .cont4 {
        top: 2870px;
        .title {
          padding: 0 30px;
          font-size: 30px;
          font-weight: 600;
          color: #363F5E;
          text-align: center;
          line-height: normal;
          margin-bottom: 12px;
          box-sizing: border-box;
        }
        .desc {
          font-size: 16px;
          font-weight: 500;
          text-align: center;
          line-height: normal;
          margin-bottom: 40px;
          color: rgba(54, 63, 94, 0.60);
        }
        .inlet {
          width: 100%;
          display: flex;
          margin-bottom: 50px;
          align-items: center;
          justify-content: space-between;
          &.show {
            display: none; 
          }
          &.hide {
            max-width: 600px;
            display: flex;
            flex-wrap: wrap; 
            margin: auto;
            justify-content:center;
          }
          .inletFlex {
            display: flex;
            flex-wrap: wrap;
            padding: 0 60px;
            justify-content: space-around;
            .round {
              display: flex;
              width: 240px;
              height: 240px;
              margin-top: 20px;
              text-align: center;
              align-items: center;
              flex-direction: column;
              justify-content: center;
              background: url(../assets/lanch_round.png) no-repeat 100%/100%;
              .top {
                width: 100%;
                font-size: 36px;
                color: #358C66;
                font-weight: 600;
                margin-bottom: 5px;
                line-height: normal;
              }
              .text {
                width: 80%;
                font-size: 20px;
                line-height: normal;
                color: rgba(54, 63, 94, 0.60);
              }
            }
          }
          .center {
            position: relative;
            width: 405px;
            height: 360px;
            color: #FFF;
            font-size: 24px;
            line-height: 30px;
            text-align: center;
            background: url(../assets/lanch_cont4.png) no-repeat 100%/100%;
            .block1 {
              width: 100px;
              top: 40px;
              left: 0;
              right: 0;
              margin: auto;
              position: absolute;
            }
            .block2 {
              position: absolute;
              width: 100px;
              top: 250px;
              left: 32px;
            }
            .block3 {
              position: absolute;
              width: 100px;
              top: 250px;
              right: 32px;
            }
          }
        }
        .viewpoint {
          width: 600px;
          display: flex;
          flex-wrap: wrap;
          margin: 30px auto 0;
          align-items: center;
          justify-content: space-around;
          .li {
            width: 280px;
            cursor: pointer;
            color: #2AB26A;
            font-size: 16px;
            font-weight: 400;
            text-align: center;
            padding: 12px 30px;
            line-height: normal;
            border-radius: 58px;
            margin-bottom: 20px;
            display: inline-block;
            box-sizing: border-box;
            font-family: PingFang SC;
            background: rgba(255, 255, 255, 0.50);
          }
        }
      }
      .cont17 {
        top: 4130px;
        .mode {
          width: 600px;
          margin: auto;
          height: 840px;
          position: relative;
          .modetype {
            position: absolute;
            width: 500px;
            height: 340px;
            flex-shrink: 0;
            line-height: normal;
            text-align: center;
            font-family: MiSans;
            padding: 70px 70px 0;
            box-sizing: border-box;
            -webkit-backdrop-filter: blur(3px);
            backdrop-filter: blur(3px);
            border-radius: 250px/170px;
          }
          .mode1 {
            left: 50px;
            top: 0;
            background: linear-gradient(159deg, rgba(92, 200, 207, 0.50) 13.2%, rgba(131, 232, 189, 0.20) 84.2%);
          }
          .mode2 {
            right: 50px;
            top: 290px;
            background: linear-gradient(313deg, rgba(92, 200, 207, 0.50) 16.48%, rgba(131, 232, 189, 0.20) 79.05%);
          }
        }
      }
      .cont5 {
        top: 4940px;
        width: 600px;
        margin: auto;
        overflow: hidden;
        height: 1010px;
        background: url(../assets/lanch_cont5bg_phone.png) no-repeat;
        background-size: 1008px 1150px;
        background-position: center -110px;
        .title {
          font-size: 32px;
          font-weight: 600;
          color: #363F5E;
          text-align: center;
          line-height: normal;
          margin-bottom: 12px;
        }
        .intro {
          position: relative;
          margin: auto;
          width: 100%;
          overflow: unset;
          background: unset;
          .topcenter {
            width: 550px;
            display: flex;
            font-size: 16px;
            font-weight: 400;
            margin: 45px auto 0;
            line-height: 22px; 
            font-family: PingFang SC;
            color: rgba(54, 63, 94, 0.80);
            justify-content: space-between;
          }
          .left, .right {
            position: absolute;
            top: 570px;
            width: 240px;
            .text1 {
              color: #363F5E;
              font-size: 28px;
              font-weight: 600;
              text-align: center;
              line-height: normal;
              margin-bottom: 12px;
            }
            .text2 {
              color: rgba(54, 63, 94, 0.60);
              text-align: center;
              font-size: 20px;
              line-height: normal;
            }
          }
          .left {
            left: 15px !important;
          }
          .right {
            position: absolute;
            left: unset;
            top: 570px;
            right: 0 !important;
          }
          .details {
            position: absolute;
            top: 450px;
            left: 0;
            right: 0;
            margin: auto;
            width: 300px;
            font-size: 16px;
            font-weight: 400;
            line-height: 26px;
            text-align: center;
            font-family: PingFang SC;
            color: rgba(54, 63, 94, 0.50);
          }
        }
      }
      .cont6 {
        top: 6040px;
        z-index: 4;
        .title {
          font-size: 32px;
          font-weight: 600;
          color: #363F5E;
          text-align: center;
          line-height: normal;
          margin-bottom: 12px;
        }
        .intro {
          width: 600px;
          margin: auto;
          height: 710px;
          display: flex;
          flex-wrap: wrap;
          padding: 20px 0;
          margin-top: 50px;
          align-items: center;
          border-radius: 24px;
          box-sizing: border-box;
          border: 1px solid #fff;
          backdrop-filter: blur(6px);
          justify-content: space-around;
          background: rgba(255, 255, 255, 0.20);
          .point {
            width: 28px;
            height: 28px;
            margin: 0 10px;
            background: url(../assets/lanch_icon1.png) no-repeat 100%/100%;
            &.point1 {
              width: 28px;
              height: 28px;
              margin: 0 17px;
            }
            &.point2 {
              width: 20px;
              height: 20px;
              margin: 0 14px;
            }
            &.point3 {
              width: 14px;
              height: 14px;
              margin: 0 17px;
            }
          }
          &.show {
            display: none; 
          }
          &.hide {
            display: flex;
          }
          .intro_desc {
            display: flex;
            align-items: center;
            &:nth-child(4) {
              margin-top: 30px;
            }
            .intro_li {
              width: 420px;
              height: 100px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              &.left {
                background: url(../assets/lanch_cont6li2.png) no-repeat 100%/100%;
              }
              &.right {
                background: url(../assets/lanch_cont6li1.png) no-repeat 100%/100%;
              }
              .left_1 {
                width: 310px;
                display: flex;
                padding: 0 10px;
                align-items: center;
                box-sizing: border-box;
                .text {
                  width: 100%;
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 1;
                  text-align: right;
                  color: rgba(54, 63, 94, 0.68);
                }
              }
              .left_2 {
                width: 100px;
                display: flex;
                margin-right: 10px;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                .icon {
                  width: 30px;
                  height: 30px;
                }
                .text {
                  font-size: 20px;
                  line-height: normal;
                  color: rgba(255, 255, 255, 0.80);
                }
              }
              .right_1 {
                width: 260px;
                display: flex;
                padding: 0 10px;
                align-items: center;
                box-sizing: border-box;
                .text {
                  width: 100%;
                  line-height: 1;
                  font-size: 14px;
                  font-weight: 400;
                  text-align: left;
                  color: rgba(54, 63, 94, 0.68);
                }
              }
              .right_2 {
                width: 155px;
                display: flex;
                margin-left: 5px;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                .icon {
                  width: 30px;
                  height: 30px;
                }
                .text {
                  font-size: 20px;
                  line-height: normal;
                  color: rgba(255, 255, 255, 0.80);
                }
              }
              .icon1 {
                background: url(../assets/lanch_cont6icon1.png) no-repeat 100%/100%;
              }
              .icon2 {
                background: url(../assets/lanch_cont6icon2.png) no-repeat 100%/100%;
              }
              .icon3 {
                background: url(../assets/lanch_cont6icon3.png) no-repeat 100%/100%;
              }
              .icon4 {
                background: url(../assets/lanch_cont6icon4.png) no-repeat 100%/100%;
              }
              .icon5 {
                background: url(../assets/lanch_cont6icon5.png) no-repeat 100%/100%;
              }
              .icon6 {
                background: url(../assets/lanch_cont6icon6.png) no-repeat 100%/100%;
              }
            }
          }
          
        }
      }
      .cont7 {
        top: 6970px;
        .title {
          width: 550px;
          margin: auto;
          font-size: 26px;
          font-weight: 600;
          color: #363F5E;
          text-align: center;
          line-height: normal;
          margin-bottom: 12px;
        }
        .desc {
          width: 600px;
          margin: auto;
          font-size: 16px;
          font-weight: 500;
          text-align: center;
          line-height: normal;
          margin-bottom: 40px;
          color: rgba(54, 63, 94, 0.60);
        }
        .intro {
          position: relative;
          margin: auto;
          width: 100%;
          height: 550px;
          display: flex;
          background: unset;
          align-items: center;
          flex-direction: column;
          justify-content: space-between;
          .left, .right {
            width: 580px;
            height: 250px;
            padding: 12px 50px 0;
            box-sizing: border-box;
          }
          .left, .right {
            .top_text {
              font-size: 22px;
              font-weight: 600;
              line-height: normal;
              margin-bottom: 15px;
              color: rgba(54, 63, 94, 0.86);
            }
            .text {
              font-size: 14px;
              line-height: normal;
              margin-bottom: 10px;
              color: rgba(54, 63, 94, 0.60);
            }
          }
          .left {
            text-align: right;
            padding: 30px 50px 0 5px;
            background: url(../assets/lanch_cont7bg_phone1.png) no-repeat 100%/100%;
            .top_text {
              margin-right: 50px;
            }
            .text:nth-child(2) {
              margin-right: 35px;
            }
            .text:nth-child(3) {
              margin-right: 17px;
            }
            .text:nth-child(4) {
              margin-right: 0px;
            }
          }
          .right {
            width: 570px;
            padding-right: 5px;
            background: url(../assets/lanch_cont7bg_phone2.png) no-repeat 100%/100%;
            .text:nth-child(2) {
              margin-left: 30px;
            }
            .text:nth-child(3) {
              margin-left: 50px;
            }
            .text:nth-child(4) {
              margin-left: 70px;
            }
          }
          .icon {
            position: absolute;
          }
          .icon1 {
            top: 380px;
            left: 65px;
            right: unset;
            width: 160px;
            height: 176px;
            animation: spin 10s linear infinite;
            background: url(../assets/lanch_cont7icon1.png) no-repeat 100%/100%;
          }
          .icon2 {
            top: 10px;
            left: unset;
            right: 50px;
            width: 180px;
            height: 180px;
            animation: spin 10s linear infinite;
            background: url(../assets/lanch_cont7icon2.png) no-repeat 100%/100%;
          }
        }
      }
      .cont8 {
        top: 7770px;
        .title {
          font-size: 32px;
          font-weight: 600;
          color: #363F5E;
          text-align: center;
          line-height: normal;
          margin-bottom: 43px;
        }
        .icon {
          position: absolute;
          top: 0;
          right: 50px;
          width: 180px;
          height: 180px;
          z-index: 2;
          transform: translate(-50%, -50%);
          animation: shake 10s ease-in-out infinite;
          background: url(../assets/lanch_cont8icon.png) no-repeat 100%/100%;
        }
        @keyframes shake {
          0%, 100% {
            transform: translateX(0);
          }
          10%, 30%, 50%, 70%, 90% {
            transform: translateX(-20px);
          }
          20%, 40%, 60%, 80% {
            transform: translateX(20px);
          }
        }
        .intro {
          position: relative;
          margin: auto;
          width: 600px;
          height: 625px;
          overflow: hidden;
          border-radius: 22px;
          background: url(../assets/lanch_cont8bg_phone.png) no-repeat 100%/100%;
          .line_text {
            font-size: 12px;
            line-height: normal;
            color: rgba(54, 63, 94, 0.60);
          }
          .ele1 {
            position: absolute;
            top: 90px;
            left: 95px;
          }
          .ele2 {
            position: absolute;
            top: 121px;
            left: 340px;
          }
          .ele3 {
            position: absolute;
            top: 451px;
            right: 165px;
          }
          .ele4 {
            position: absolute;
            top: 300px;
            left: 351px;
          }
          .ele5 {
            position: absolute;
            top: 452px;
            right: 365px;
          }
          .ele6 {
            position: absolute;
            bottom: 250px;
            left: 275px;
          }
          .ele7 {
            position: absolute;
            top: 30px;
            left: 320px;
            width: 88px;
            height: 88px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .icon1 {
              width: 24px;
              height: 24px;
              margin-bottom: 8px;
              background: url(../assets/lanch_cont8icon1.png) no-repeat 100%/100%;
            }
            .text {
              font-size: 16px;
              line-height: normal;
              color: rgba(54, 63, 94, 0.80);
            }
          }
          .ele8 {
            position: absolute;
            width: 388px;
            height: 140px;
            top: 150px;
            left: 135px;
            padding: 15px 20px;
            box-sizing: border-box;
            .text {
              font-size: 20px;
              font-weight: 600;
              color: #363F5E;
              text-align: center;
              line-height: normal;
              margin-bottom: 2px;
            }
            .text1 {
              font-size: 15px;
              text-align: center;
              line-height: normal;
              margin-bottom: 10px;
              color: rgba(54, 63, 94, 0.66);
            }
            .list {
              display: flex;
              flex-wrap: wrap;
              font-size: 14px;
              font-weight: 400;
              line-height: normal;
              align-items: center;
              justify-content: space-between;
              color: rgba(54, 63, 94, 0.50);
              p {
                width: 50%;
                margin-bottom: 4px;
              }
            }
          }
          .ele9 {
            position: absolute;
            width: 320px;
            height: 115px;
            top: 485px;
            right: 30px;
            display: flex;
            padding: 15px 20px;
            align-items: center;
            flex-direction: column;
            box-sizing: border-box;
            justify-content: center;
            .text {
              font-size: 20px;
              font-weight: 600;
              color: #363F5E;
              line-height: normal;
              margin-bottom: 2px;
            }
            .text1 {
              font-size: 15px;
              line-height: normal;
              margin-bottom: 10px;
              color: rgba(54, 63, 94, 0.66);
            }
            .buy {
              font-size: 14px;
              font-weight: 400;
              line-height: normal;
              color: rgba(54, 63, 94, 0.60);
            }
          }
          .ele10 {
            position: absolute;
            width: 180px;
            height: 95px;
            top: 320px;
            left: 22px;
            display: flex;
            padding: 15px;
            align-items: center;
            flex-direction: column;
            box-sizing: border-box;
            justify-content: center;
            .text {
              font-size: 20px;
              font-weight: 600;
              color: #363F5E;
              line-height: normal;
              margin-bottom: 2px;
            }
            .text1 {
              font-size: 12px;
              line-height: normal;
              color: rgba(54, 63, 94, 0.66);
            }
          }
          .ele11 {
            position: absolute;
            top: 330px;
            left: 330px;
            width: 88px;
            height: 88px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .icon1 {
              width: 24px;
              height: 24px;
              margin-bottom: 8px;
              background: url(../assets/lanch_cont8icon1.png) no-repeat 100%/100%;
            }
            .text {
              font-size: 16px;
              line-height: normal;
              color: rgba(54, 63, 94, 0.80);
            }
          }
          .ele12 {
            position: absolute;
            width: 230px;
            height: 95px;
            top: 485px;
            right: 350px;
            display: flex;
            padding: 15px 20px;
            align-items: center;
            flex-direction: column;
            box-sizing: border-box;
            justify-content: center;
            .text {
              font-size: 14px;
              font-weight: 600;
              color: #363F5E;
              line-height: normal;
              margin-bottom: 2px;
            }
            .text1 {
              font-size: 12px;
              line-height: normal;
              color: rgba(54, 63, 94, 0.66);
            }
          }
        }
        .intro::after, .intro::before{
          content: '';
          width: 160px;
          height: 4px;
          position: absolute;
          top: 2px;
          left: 150px
        }
        .intro::before{
          left: 50px;
          animation: run 4s linear infinite;
          background: url(../assets/lanch_border2.png) no-repeat 100%/100%;
          transform: translate(-50%, -50%);
        }
        .intro::after{
          animation: run2 4s linear infinite;
          background: url(../assets/lanch_border1.png) no-repeat 100%/100%;
          transform: translate(-50%, -50%);
        }
      }
      .cont9 {
        top: 8550px;
        .title {
          font-size: 32px;
          font-weight: 600;
          color: #363F5E;
          text-align: center;
          line-height: normal;
          margin-bottom: 30px;
        }
        .intro {
          position: relative;
          width: 600px;
          height: 480px;
          display: flex;
          margin: auto;
          overflow: hidden;
          align-items: center;
          border-radius: 24px;
          box-sizing: border-box;
          border: 1px solid #fff;
          backdrop-filter: blur(6px);
          justify-content: space-around;
          background: rgba(255, 255, 255, 0.20);
          &::after, &::before{
            content: '';
            width: 160px;
            height: 4px;
            position: absolute;
            top: 2px;
            left: 150px
          }
          &::before{
            left: 50px;
            animation: run 4s linear infinite;
            background: url(../assets/lanch_border2.png) no-repeat 100%/100%;
            transform: translate(-50%, -50%);
          }
          &::after{
            animation: run2 4s linear infinite;
            background: url(../assets/lanch_border1.png) no-repeat 100%/100%;
            transform: translate(-50%, -50%);
          }
          .left {
            position: absolute;
            left: -20px;
            bottom: -20px;
            width: 120px;
            height: 120px;
            transform: translate(-50%, -50%);
            animation: shake1 20s ease-in-out infinite;
            background: url(../assets/lanch_cont9img.png) no-repeat 100%/100%;
          }
          @keyframes shake1 {
            0%, 100% {
              transform: translateX(0);
              transform: translatey(0);
            }
            10%, 30%, 50%, 70%, 90% {
              transform: translateX(-20px);
              transform: translatey(-20px);
            }
            20%, 40%, 60%, 80% {
              transform: translatey(20px);
              transform: translateX(20px);
            }
          }
          .right {
            width: 100%;
            .topcont {
              margin: auto;
              width: 580px;
              height: 94px;
              display: flex;
              align-items: center;
              justify-content: space-around;
              .user {
                width: 88px;
                height: 88px;
                display: flex;
                border-radius: 20px;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                backdrop-filter: blur(6px);
                background: rgba(255, 255, 255, 0.40);
                .icon1 {
                  width: 24px;
                  height: 24px;
                  margin-bottom: 8px;
                  background: url(../assets/lanch_cont8icon1.png) no-repeat 100%/100%;
                }
                .text {
                  font-size: 16px;
                  line-height: normal;
                  color: rgba(54, 63, 94, 0.80);
                }
              }
              .text_line {
                display: flex;
                font-size: 12px;
                line-height: normal;
                align-items: center;
                color: rgba(54, 63, 94, 0.50);
                .arrow {
                  width: 76px;
                  height: 27px;
                  margin-left: 5px;
                  display: inline-block;
                  background: url(../assets/lanch_cont9arrow.png) no-repeat 100%/100%;
                }
              }
              .block {
                width: 250px;
                height: 94px;
                display: flex;
                padding: 15px 20px;
                align-items: center;
                border-radius: 24px;
                flex-direction: column;
                box-sizing: border-box;
                justify-content: center;
                background: rgba(255, 255, 255, 0.40);
                .text {
                  font-size: 20px;
                  font-weight: 600;
                  color: #363F5E;
                  line-height: normal;
                  margin-bottom: 2px;
                }
                .text1 {
                  font-size: 15px;
                  line-height: normal;
                  color: rgba(54, 63, 94, 0.66);
                }
              }
            }
            .list {
              width: 90%;
              height: 290px;
              display: flex;
              padding: 10px 0;
              flex-wrap: wrap;
              margin: 30px auto 0;
              border-radius: 20px;
              align-items: center;
              box-sizing: border-box;
              justify-content: space-around;
              background: rgba(255, 255, 255, 0.30);
              .li{
                width: 80%;
                height: 70px;
                text-align: center;
                line-height: normal;
                .num {
                  font-size: 18px;
                  font-weight: 600;
                  color: rgba(54, 63, 94, 0.16);
                }
                .text{
                  font-size: 14px;
                  font-weight: 400;
                  color: rgba(54, 63, 94, 0.56);
                }
              }
            }
          }
        }
      }
      .cont10 {
        z-index: 12;
        top: 9190px;
        .title {
          font-size: 32px;
          font-weight: 600;
          color: #363F5E;
          text-align: center;
          line-height: normal;
          margin-bottom: 30px;
        }
        .intro {
          width: 600px;
          display: flex;
          padding: 0 10px;
          margin: 50px auto 0;
          box-sizing: border-box;
          justify-content: space-between;
          &.show {
            display: none;
          }
          &.hide {
            display: flex;
          }
          .line1 {
            width: 0px;
            height: 2260px;
            margin-top: 7px;
            border: 1px dashed #2AB26A;
          }
          .list {
            line-height: normal;
            .li {
              position: relative;
              margin: 0 0 35px 20px;
              &::after {
                position: absolute;
                top: 0;
                left: -31px;
                content: '';
                width: 20px;
                height: 20px;
                background: url(../assets/lanch_icon1.png) no-repeat 100%/100%;
              }
              .li_title {
                font-size: 18px;
                font-weight: 600;
                color: #363F5E;
              }
              .li_text {
                font-size: 14px;
                line-height: normal;
                color: rgba(54, 63, 94, 0.66);
              }
            }
          }
        }
      }
      .cont11 {
        z-index: 12;
        top: 10730px;
        .title {
          font-size: 32px;
          font-weight: 600;
          color: #363F5E;
          text-align: center;
          line-height: normal;
          margin-bottom: 40px;
        }
        .intro {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .userimg {
            position: absolute;
            right: 0;
            top: -183px;
            z-index: 2;
            width: 200px;
            height: 200px;
            transform: rotateY(180deg);
            background: url(../assets/lanch_cont11img.png) no-repeat 100%/100%;
          }
          .scan {
            display: none;
          }
          .scan1 {
            display: block;
            position: absolute;
            top: -125px;
            right: 110px;
            width: 140px;
            height: 250px;
            transform: rotateY(180deg);
            background: url(../assets/lanch_cont11img1.png) no-repeat 100%/100%;
            background-size: 140px 250px;
            &.active {
              transition:none;
              background-size: 140px 250px;
            }
          }
          .datalist {
            width: 600px;
            display: flex;
            flex-wrap: wrap;
            margin: auto;
            .datali {
              width: 100%;
              height: 80px;
              display: flex;
              .point {
                width: 20px;
                height: 20px;
                margin: 3px 10px 0 0;
                background: url(../assets/lanch_icon1.png) no-repeat 100%/100%;
              }
              .data {
                flex: 1;
                padding-right: 10px;
                box-sizing: border-box;
                .top {
                  color: #363F5E;
                  font-size: 18px;
                  font-weight: 600;
                  margin-bottom: 4px;
                  line-height: normal;
                }
                .text {
                  font-size: 16px;
                  line-height: normal;
                  color: rgba(54, 63, 94, 0.66);
                }
              }
            }
          }
        }
      }
      .cont12 {
        top: 11700px;
        .intro {
          position: relative;
          width: 600px;
          height: 600px;
          display: flex;
          margin: auto;
          align-items: center;
          border-radius: 20px;
          justify-content: space-around;
          background: linear-gradient(180deg, rgba(152, 217, 182, 0.18) 6.92%, rgba(200, 227, 213, 0.16) 100%);
          .echarDom {
            width: 600px;
            height: 600px;
          }
          .details {
            position: absolute;
            top: 600px;
            height: 0;
            width: 480px;
            height: 420px;
            overflow: hidden;
            padding: 24px 20px;
            line-height: normal;
            border-radius: 24px;
            box-sizing: border-box;
            backdrop-filter: blur(6px);
            background: rgba(255, 255, 255, 0.9);
            &.Total {
              display: none;
              text-align: center;
              padding: 24px 80px;
              .title {
                font-size: 20px;
                font-weight: 600;
                color: #363F5E;
                margin-bottom: 16px;
              }
              .block {
                text-align: center;
                font-size: 14px;
                margin-bottom: 24px;
                .text {
                  color: rgba(54, 63, 94, 0.50);
                }
                .desc {
                  color: #363F5E;
                }
              }
              
            }
            &.Single {
              .title {
                font-size: 20px;
                font-weight: 600;
                color: #363F5E;
                text-align: center;
                margin-bottom: 16px;
              }
              .dataList {
                .data_top {
                  display: flex;
                  font-size: 16px;
                  color: #363F5E;
                  align-items: center;
                  span {
                    width: 8px;
                    height: 8px;
                    margin-right: 8px;
                    border-radius: 100%;
                    display: inline-block;
                    background: #363F5E;
                  }
                }
                .text {
                  font-size: 14px;
                  color: rgba(54, 63, 94, 0.66);
                  span {
                    font-weight: 400;
                    color: rgba(54, 63, 94, 0.40);
                  }
                }
              }
            }
            &.font12 {
              padding: 12px 10px;
              .title {
                font-size: 16px;
                font-weight: 600;
                color: #363F5E;
                text-align: center;
                margin-bottom: 8px;
              }
              .dataList {
                margin-bottom: 5px;
                .data_top {
                  display: flex;
                  font-size: 14px;
                  color: #363F5E;
                  align-items: center;
                  span {
                    width: 8px;
                    height: 8px;
                    margin-right: 8px;
                    border-radius: 100%;
                    display: inline-block;
                    background: #363F5E;
                  }
                }
                .text {
                  font-size: 12px;
                  color: rgba(54, 63, 94, 0.66);
                  span {
                    font-weight: 400;
                    color: rgba(54, 63, 94, 0.40);
                  }
                }
              }
            }
          }
        }
      }
      .cont13 {
        top: 12360px;
        z-index: 6;
        width: 100%;
        .title {
          font-size: 32px;
          font-weight: 600;
          color: #363F5E;
          text-align: center;
          line-height: normal;
          margin-bottom: 40px;
        }
        .teamlist {
          width: 600px;
          margin: auto;
          display: flex;
          flex-wrap: wrap;
          .teamli {
            position: relative;
            width: 180px;
            height: 260px;
            overflow: hidden;
            border-radius: 24px;
            margin: 0 30px 24px 0;
            transition: all .3s ease-in-out;
            background: rgba(255, 255, 255, 0.60);
            &:hover {
              box-shadow: 0 0 4px 4px rgba(42, 178, 106, 0.50);
              -webkit-transform: translateY(-10px);
              -ms-transform: translateY(-10px);
              transform: translateY(-10px);
              .name {
                background: rgba(42, 178, 106, 0.50);
              }
            }
            &:nth-child(3n){
              margin-right: 0;
            }
            &:nth-child(4n){
              margin-right: 30px;
            }
            .userimg {
              width: 180px;
              height: 260px;
              img {
                width: 180px;
                min-height: 260px;
              }
            }
            .name {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 50px;
              display: flex;
              color: #FFF;
              font-size: 16px;
              text-align: center;
              line-height: normal;
              align-items: center;
              justify-content: center;
              background: rgba(255, 255, 255, 0.6);
              text-shadow: 0px 2px 16px rgba(54, 63, 94, 0.6)
            }
          }
        }
        .detailsInfo {
          position: absolute;
          top: 350px;
          left: 0;
          right: 0;
          margin: auto;
          width: 600px;
          padding: 30px;
          text-align: center;
          background: #FFF;
          border-radius: 24px;
          line-height: normal;
          box-sizing: border-box;
          &.show {
            display: none;
          }
          &.hide {
            display: block;
          }
          &.top1 {
            top: 630px;
            z-index: 15;
          }
          &.top2 {
            top: 400px;
            z-index: 15;
          }
          .name {
            font-size: 20px;
            font-weight: 600;
            color: #363F5E;
            margin-bottom: 5px;
          }
          .synopsis {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 15px;
            color: rgba(78, 89, 105, 0.80);
          }
          .text {
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            text-align: center;
            color: rgba(78, 89, 105, 0.80);
          }
        }
      }
      .cont14 {
        // top: 7930px;
        z-index: 5;
        top: 13330px;
        position: relative;
        .title {
          font-size: 32px;
          font-weight: 600;
          color: #363F5E;
          text-align: center;
          line-height: normal;
          margin-bottom: 30px;
        }
        .organList {
          width: 600px;
          margin: auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          img {
            width: 240px;
            height: 100px;
            transition: all .3s ease-in-out;
            &:hover {
              -webkit-transform: translateY(-10px);
              -ms-transform: translateY(-10px);
              transform: translateY(-10px);
            }
          }
        }
        .organInfo {
          position: absolute;
          top: 270px;
          left: 0;
          right: 0;
          margin: auto;
          width: 600px;
          padding: 30px;
          font-size: 14px;
          background: #FFF;
          border-radius: 24px;
          line-height: normal;
          box-sizing: border-box;
          color: rgba(78, 89, 105, 0.80);
        }
      }
      .cont15 {
        top: 13660px;
        z-index: 1;
        .title {
          font-size: 32px;
          font-weight: 600;
          color: #363F5E;
          text-align: center;
          line-height: normal;
          margin-bottom: 30px;
        }
        .communityList {
          width: 600px;
          height: 300px;
          margin: auto;
          &.show {
            display: none;
          }
          &.hide {
            display: block;
            overflow: hidden;
          }
          .progress {
            position: relative;
            width: 300px;
            height: 6px;
            overflow: hidden;
            background: rgba(255, 255, 255, .5);
            border-radius: 4px;
            margin: -35px auto 0;
            .scrollBar {
              position: absolute;
              top: 0;
              left: 0;
              width: 50px;
              height: 6px;
              border-radius: 4px;
              background: #fff;
            }
          }
          .list {
            width: 100%;
            display: flex;
            padding: 0 10px;
            overflow-x: auto;
            overflow-y: hidden;
            align-items: center;
            box-sizing: border-box;
            .community {
              width: 380px;
              cursor: pointer;
              margin: 0 20px 50px 0;
              transition: none;
              &:hover {
                -webkit-transform: none;
                -ms-transform: none;
                transform: none;
              }
              &:nth-child(3n) {
                margin-right: 20px;
              }
              &:last-child {
                margin-right: 0;
              }
              .act_img {
                width: 380px;
                height: 220px;
                display: flex;
                line-height: 0;
                overflow: hidden;
                align-items: center;
                img {
                  width: 380px;
                  min-height: 220px;
                }
              }
              .act_name {
                width: 100%;
                font-size: 18px;
                font-weight: 500;
                overflow: hidden;
                margin: 10px 0 5px;
                white-space: nowrap;
                line-height: normal;
                box-sizing: border-box;
                text-overflow: ellipsis;
                color: rgba(54, 63, 94, 0.88);
              }
              .act_time {
                font-size: 14px;
                font-weight: 400;
                line-height: normal;
                box-sizing: border-box;
                color: rgba(54, 63, 94, 0.60);
              }
            }
          }
        }
      }
    }
  }
  .lan_En.Lanchpad {
    .content  {
      &.content1 {
        width: 100%;
        min-width: 600px;
        height: 14310px;
        overflow: hidden;
        background: url("../assets/lanchpadbg.png") no-repeat center;
        background-size: 100% 14310px;
      }
      .cont3 {
        .text_desc {
          .title {
            font-size: 24px;
            line-height: 1;
          }
          .text {
            font-size: 14px;
          }
        }
      }
      .cont5 {
        .title {
          font-size: 24px;
        }
        .intro {
          .left {
            .text1 {
              font-size: 16px;
              text-align: left;
            }
            .text2 {
              font-size: 14px;
              text-align: left;
            }
          }
          .right {
            right: 15px !important;
            .text1 {
              font-size: 16px;
              text-align: right;
            }
            .text2 {
              font-size: 14px;
              text-align: right;
            }
          }
        }
      }
      .cont6 {
        .title {
          font-size: 24px;
        }
        .intro {
          margin-top: 40px;
        }
      }
      .cont7 {
        top: 6970px;
        .title {
          font-size: 24px;
        }
        .desc {
          margin-bottom: 20px;
        }
      }
      .cont8 {
        .title {
          position: relative;
          z-index: 5;
        }
        .intro {
          .ele5 {
            top: 452px;
          }
          .ele6 {
            bottom: 250px;
          }
        }
      }
      .cont9 {
        .title {
          font-size: 30px;
        }
        .intro {
          .right {
            .topcont {
              .block {
                padding: 15px 5px;
                .text {
                  font-size: 16px;
                }
                .text1 {
                  font-size: 12px;
                }
              }
            }
          }
        }
      }
      .cont10 {
        .intro {
          .line1 {
            height: 2515px;
          }
        }
      }
      .cont11 {
        top: 10950px;
        .intro {
          .userimg {
            height: 335px;
          }
          .scan.active {
            height: 380px;
            background-size: 234px 380px;
          }
          .datalist {
            .datali {
              height: 85px;
              .data {
                .top {
                  font-size: 20px;
                }
                .text {
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
      .cont12 {
        top: 11930px;
        .intro {
          .details{
            height: 300px;
            &.font12 {
              height: 450px;
            }
          }
        }
      }
      .cont13 {
        top: 12600px;
      }
      .cont14 {
        top: 13580px;
      }
      .cont15 {
        top: 13895px;
      }
    }
  }
}

</style>

